import {t} from "../../../../../services/i18n";
import EventTypeStep from "./Steps/EventTypeStep";
import React, {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import BasicInformation from "./Steps/BasicInformation";
import * as yup from "yup";
import {addToSelectionsTree, setError, updateCurrStep, updateTempSelection} from "../../../../../redux/stepperSlice";
import {store} from "../../../../../redux/store";
import moment from "moment";
import RepeatConfiguration from "./Steps/RepeatConfiguration";
import {
    daysEnum,
    dbDateFormat,
    dbTimeFormat,
    isMultiPayForSlotRepeat,
    getPenaltiesTags,
    getMessageToUserFromError,
    getSettingsObjectByType,
    hasLimitedCoachViewSchedule,
    hasPermissions,
    isBoxInTrial,
    isStringWithoutEmoji,
    snakeToCamel,
    targetAudienceTasks, normalizeText
} from "../../../../../services/Helpers";
import SessionSettings from "./Steps/SessionSettings";
import SuccessStep from "../../../../common/SuccessStep";
import {flowOptions, getSuccessProps, userFlowsOnly} from "./FlowOptions";
import MultiDayConfiguration from "./Steps/MultiDayConfiguration";
import OneOnOneType from "./Steps/OneOnOneType";
import UserAndMembershipSelection from "./Steps/UserAndMembershipSelection";
import PaymentMethod from "./Steps/PaymentMethod";
import {
    EMAIL,
    APPOINTMENT,
    ENTER_DEBT,
    FREE_PURCHASE,
    messageAudience,
    PUSH,
    SERIES_FUTURE_SESSIONS_EDIT_TYPE,
    SINGLE_SESSION_EDIT_TYPE,
    SMS,
    WHATSAPP,
    SCHEDULE_TYPE,
    USER_TYPE,
    customFieldTypes,
    HOK,
    TRIAL,
    IMMEDIATE,
    ONETIME,
    seriesPaymentDBTranslate,
    boxSettingsProps,
    USER_FIELDS,
    familyArray,
    HEAD_TYPES,
    USER_TYPE_TC, SCHEDULE_TYPE_TC,
    SITE_TRIAL_SETTINGS, createdStatusId, SITE_LEAD_FORM_SETTINGS, siteFormLeadFieldOptions, messageTemplateScopes,
    SPACES_TYPE, USER_SITE_FIELDS, RELATIVE, FULL, HUGIM_FORM, DEFAULTS, GROUP_FORM, CHARGE_SETTING, siteChargeOptions,APPOINTMENT_FORM, APPOINTMENT_MANAGEMENT_FORM,
    HUG_FULL_BOOKING, HUG_DAY_BOOKING, HUG_PARTIAL_BOOKING, TRACK_FULL, TRACK_RELATIVE, TRACK_HALF, TRACK_FORM
} from "../../../../../services/ConstHelper";
import AvailabilitySlotSelection from "./Steps/AvailabilitySlotSelection";
import EditMultiDayConfig from "./Steps/EditMultiDayConfig";
import SpaceConfiguration from "./Steps/SpaceConfiguration";
import MemberDetails from "../../../Forms/Users/MemberDetails";
import StaffMemberRoleSelection from "../../../Forms/Users/StaffMemberRoleSelection";
import { emailRegex, validateAfterEmailSymbol } from "../../../../../services/validationService";
import {
    InternalPromoRoleOptions,
    MembershipTypes,
    Roles,
    StaffMemberRoles
} from "../../../../../Configs/DatabaseConsts";
import {checkEmailChange, isEmailAvailable} from "../../../../../redux/UserFlowSlice";
import BlockedTime from "./Steps/BlockedTime";
import MessageType from "../../../Forms/Messages/MessageType";
import MessageDetails from "../../../Forms/Messages/MessageDetails";
import PenaltySettings from "../../../Forms/Settings/Penalties/PenaltySettings";
import PenaltyExtraProperties from "../../../Forms/Settings/Penalties/PenaltyExtraProperties";
import PenaltySummary from "../../../Summaries/PenaltySummary";
import TaskDetails from "../../../Forms/Tasks/TaskDetails";
import CustomFieldSelection from "./Steps/CustomFieldSelection";
import CustomFieldSettings from "./Steps/CustomFieldSettings";
import uniqBy from "lodash-es/uniqBy";
import SeriesPaymentOptions from "./Steps/SeriesPaymentOptions";
import HugPaymentsOptions from "./Steps/HugPaymentsOptions";
import Payment from "./Steps/Payment";
import PersonalDetails from "./Steps/PersonalDetails";
import CreateTaskType from "../../../../../../web/src/components/Tasks/TasksSettings/CreateTaskType";
import TrackDetails from "./Steps/TrackDetails";
import RequiredFieldsSettings from "../../../Forms/Settings/RequiredFieldsSettings";
import AccountCardsSettings from "../../../Forms/Settings/AccountCardsSettings";
import OrganizationPriceList from "../../../Forms/Settings/OrganizationPriceList";
import ChooseGroupConnectionUser from "../../../Forms/Groups/ChooseGroupConnectionUser";
import GroupConnectionAddUser from "../../../Forms/Groups/GroupConnectionAddUser";
import SendLink from "../../../Forms/Messages/SendLink";
import SiteTrialSettings from "./Steps/SiteTrialSettings";
import GatesApplySettings from "../../../Forms/Gates/GatesApplySettings";
import GatesActivityHours from "../../../Forms/Gates/GatesActivityHours";
import SiteLeadFormSettings from "../../../Forms/SiteLeadFormSettings";
import EmailAfterPurchase from "../../../Forms/Settings/EmailAfterPurchase";
import DocumentsAutoSendSettings from "../../../Forms/Settings/DocumentsAutoSend/DocumentsAutoSendSettings";
import AdvancedSeriesSettings from "./Steps/AdvancedSeriesSettings";
import Export from "../../../../../../web/src/components/Finance/Export";
import SendInvoicesReport from "../../../../../../web/src/components/Finance/SendInvoicesReport";
import SendDoctorJournalReport from "../../../../../../web/src/components/Finance/SendDoctorJournalReport";
import NoteTemplate from "./Steps/NoteTemplate";
import Note from "./Steps/Note";
import { conditionalRequiredSchema } from "../../../../../services/stepperService";
import GroupDetails from "./Steps/GroupDetails";
import FlowForm from "./Steps/FlowForm";
import FlowFormChoice from "./Steps/FlowFormChoice";
import FlowFormManage, {DISPLAY_MODE_SPECIFIC} from "./Steps/FlowFormManage";
import {getTypeByRole} from "../../../../../../web/src/components/Tasks/TasksHelper";
import {closeModal, CREATE_EVENT_MODAL, openModal, STEPPER_CONFIRM_MODAL} from "../../../../../redux/modalManagerSlice";
import {fetchApi} from "../../../../../services/HTTP";
import BuildUniformReport from "../../../../../../web/src/components/Finance/BuildUniformReport";
import UserChargeSetting from "./Steps/UserChargeSetting";
import UserNoteExport from "./Steps/UserNoteExport";
import {handleEventSpacesRelation} from "../../../../../services/ScheduleService";
import ChooseHug from "./ChooseHug/ChooseHug";
import ChooseTrack from "./ChooseTrack/ChooseTrack";
import ChooseTrackCourses from "./ChooseTrackCourses/ChooseTrackCourses";
import BookingType from "./Steps/BookingType";
import { setLoadingModal } from "../../../../../redux/modalManagerSlice";
import PromoCode from "./Steps/PromoCode";
import {checkPromoFlowIsInternal} from "../../../../../services/PromoCodeHelpers";
import CourseLimitations from "./CourseLimitations/CourseLimitations";
import RequiredCourseFromTrack from "./Steps/RequiredCourseFromTrack";
import { getLocationsByRivhitIdOptions } from "../../../../../redux/boxSlice";
import BasicInfoAppointment from "./Steps/BasicInfoAppointment";
import AppointmentWaitlistAdd from "./Steps/AppointmentWaitlistAdd";
import SwapType from "./Steps/SwapType";
import ChooseSwapDay from "./Steps/ChooseSwapDay";
import SwapDaySummary from "./Steps/SwapDaySummary";

export const optionalSteps = {
    EVENT_TYPE: 'EVENT_TYPE',
    APPOINTMENT_OR_AVAILABILITY_STEP: 'APPOINTMENT_OR_AVAILABILITY_STEP',
    BASIC_INFO: 'BASIC_INFO',
    BASIC_INFO_APPOINTMENT: 'BASIC_INFO_APPOINTMENT',
    REPEAT_CONFIG: 'REPEAT_CONFIG',
    AVAILABILITY_CONFIG: 'AVAILABILITY_CONFIG',
    MULTI_DAY_CONFIG: 'MULTI_DAY_CONFIG',
    SETTINGS: 'SETTINGS',
    USER_AND_MEMBERSHIP_SELECTION: 'USER_AND_MEMBERSHIP_SELECTION',
    PAYMENT_METHOD_SELECTION: 'PAYMENT_METHOD_SELECTION',
    SUCCESS_PAGE: 'SUCCESS_PAGE',
    EDIT_MULTI_DAY_CONFIG: 'EDIT_MULTI_DAY_CONFIG',
    MEMBER_DETAILS: 'MEMBER_DETAILS',
    STAFF_MEMBER_ROLE_SELECT: 'STAFF_MEMBER_ROLE_SELECT',
    BLOCKED_TIME: 'BLOCKED_TIME',
    MESSAGE_TYPE: 'MESSAGE_TYPE',
    MESSAGE_DETAILS: 'MESSAGE_DETAILS',
    EMAIL_AFTER_PURCHASE: 'EMAIL_AFTER_PURCHASE',
    DOCUMENTS_AUTO_SEND: 'DOCUMENTS_AUTO_SEND',
    SPACE_CONFIGURATION: 'SPACE_CONFIGURATION',
    PENALTY_SETTINGS: 'PENALTY_SETTINGS',
    PENALTY_EXTRA_PROPERTIES: 'PENALTY_EXTRA_PROPERTIES',
    PENALTY_SUMMARY: 'PENALTY_SUMMARY',
    TASK_DETAILS: 'TASK_DETAILS',
    TASK_TYPE: 'TASK_TYPE',
    SEND_CONVERT_LINK: 'SEND_CONVERT_LINK',
    CUSTOM_FIELD_TYPE_SELECTION: 'CUSTOM_FIELD_TYPE_SELECTION',
    CUSTOM_FIELD_SETTINGS: 'CUSTOM_FIELD_SETTINGS',
    SERIES_PAYMENT_OPTIONS: 'SERIES_PAYMENT_OPTIONS',
    CHOOSE_HUG_PAYMENT_TYPE: 'CHOOSE_HUG_PAYMENT_TYPE',
    CHOOSE_TRACK_PAYMENT_OPTIONS: 'CHOOSE_TRACK_PAYMENT_OPTIONS',
    PAYMENT: 'PAYMENT',
    SEND_ONE_TIME_MEMBERSHIP_LINK: 'SEND_ONE_TIME_MEMBERSHIP_LINK',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    LEAD_TO_CONVERT_PERSONAL_DETAILS: 'LEAD_TO_CONVERT_PERSONAL_DETAILS',
    REQUIRED_FIELDS_SETTINGS: 'REQUIRED_FIELDS_SETTINGS',
    ACCOUNT_CARDS_SETTINGS: 'ACCOUNT_CARDS_SETTINGS',
    ORGANIZATION_PRICE_LIST: 'ORGANIZATION_PRICE_LIST',
    CHOOSE_GROUP_CONNECTION_USER: 'CHOOSE_GROUP_CONNECTION_USER',
    GROUP_CONNECTION_ADD_USER: 'GROUP_CONNECTION_ADD_USER',
    SITE_TRIAL_SETTINGS: 'SITE_TRIAL_SETTINGS',
    GATES_APPLY_SETTINGS: 'GATES_APPLY_SETTINGS',
    GATES_ACTIVITY_HOURS: 'GATES_ACTIVITY_HOURS',
    SITE_LEAD_FORM_SETTINGS: 'SITE_LEAD_FORM_SETTINGS',
    ADVANCED_SERIES_SETTINGS: 'ADVANCED_SERIES_SETTINGS',
    EXPORT: 'EXPORT',
    SEND_INVOICES_REPORT: 'SEND_INVOICES_REPORT',
    SEND_DOCTOR_JOURNAL_REPORT: 'SEND_DOCTOR_JOURNAL_REPORT',
    NOTE_TEMPLATE: 'NOTE_TEMPLATE',
    NOTE: 'NOTE',
    GROUP_DETAILS: 'GROUP_DETAILS',
    FLOW_FORM: 'FLOW_FORM',
    FLOW_FORM_CHOICE: 'FLOW_FORM_CHOICE',
    FLOW_FORM_MANAGE: 'FLOW_FORM_MANAGE',
    SEND_DEBT_LINK: 'SEND_DEBT_LINK',
    BUILD_UNIFORM_REPORT: 'BUILD_UNIFORM_REPORT',
    SEND_CONFIRMATION_LINK: 'SEND_CONFIRMATION_LINK',
    BOOK_TO_HUG_CREATE_LEAD: 'BOOK_TO_HUG_CREATE_LEAD',
    USER_CHARGE_SETTING: 'USER_CHARGE_SETTING',
    PROMO_CODE: 'PROMO_CODE',
    USER_NOTE_EXPORT: 'USER_NOTE_EXPORT',
    CHOOSE_HUG: 'CHOOSE_HUG',
    SWAP_TYPE: 'SWAP_TYPE',
    CHOOSE_SWAP_DAY: 'CHOOSE_SWAP_DAY',
    SWAP_DAY_SUMMARY: 'SWAP_DAY_SUMMARY',
    CHOOSE_TRACK: 'CHOOSE_TRACK',
    CHOOSE_TRACK_COURSES: 'CHOOSE_TRACK_COURSES',
    BOOKING_TYPE: 'BOOKING_TYPE',
    SEND_ALL_DEBTS_LINK: 'SEND_ALL_DEBTS_LINK',
    TRACK_DETAILS: 'TRACK_DETAILS',
    TRACK_PAYMENT_OPTIONS: 'TRACK_PAYMENT_OPTIONS',
    TRACK_ADVANCED: 'TRACK_ADVANCED',
    TRACK_TIME_CONFIG: 'TRACK_TIME_CONFIG',
    TRACK_EDIT_TIME_CONFIG: 'TRACK_EDIT_TIME_CONFIG',
    TRACK_SETTINGS: 'TRACK_SETTINGS',
    COURSE_LIMITATIONS: 'COURSE_LIMITATIONS',
    REQUIRED_COURSE_FROM_TRACK: 'REQUIRED_COURSE_FROM_TRACK',
    APPOINTMENT_WAITLIST: 'APPOINTMENT_WAITLIST',
}

export const renderStep = {
    EVENT_TYPE: (props) => renderEventTypeSelectionStep(props),
    APPOINTMENT_OR_AVAILABILITY_STEP: (props) => renderAppointmentOrAvailabilityStep(props),
    BASIC_INFO: (props) => renderBasicInfoStep(props),
    BASIC_INFO_APPOINTMENT: (props) => renderBasicInfoAppointmentStep(props),
    REPEAT_CONFIG: (props) => renderRepeatConfigStep(props),
    AVAILABILITY_CONFIG: (props) => renderAvailabilityConfigStep(props),
    MULTI_DAY_CONFIG: (props) => renderMultiDayConfigStep(props),
    SETTINGS: (props) => renderSettingsStep(props),
    USER_AND_MEMBERSHIP_SELECTION: (props) => renderUserAndMembershipSelection(props),
    PAYMENT_METHOD_SELECTION: (props) => renderPaymentMethodSelection(props),
    SUCCESS_PAGE: (props) => renderSuccessStep(props),
    EDIT_MULTI_DAY_CONFIG: (props) => renderEditMultiDayConfig(props),
    MEMBER_DETAILS: (props) => renderMemberDetails(props),
    STAFF_MEMBER_ROLE_SELECT: (props) => renderStaffMemberRoleSelect(props),
    BLOCKED_TIME: (props) => renderBlockedTime(props),
    MESSAGE_TYPE: (props) => renderMessageTypeSelect(props),
    MESSAGE_DETAILS: (props) => renderMessageDetails(props),
    APPOINTMENT_WAITLIST: (props) => renderAppointmentWaitlistAdd(props),
    EMAIL_AFTER_PURCHASE: (props) => renderEmailAfterPurchase(props),
    DOCUMENTS_AUTO_SEND: (props) => renderDocumentsAutoSendSettings(props),
    SPACE_CONFIGURATION: (props) => renderSpaceConfigStep(props),
    PENALTY_SETTINGS: (props) => renderPenaltySettingsConfigStep(props),
    PENALTY_EXTRA_PROPERTIES: (props) => renderPenaltyExtraPropertiesConfigStep(props),
    PENALTY_SUMMARY: (props) => renderPenaltySummaryStep(props),
    TASK_TYPE: (props) => renderTaskTypeStep(props),
    TASK_DETAILS: (props) => renderTaskDetailsStep(props),
    SEND_CONVERT_LINK: (props) => renderSendLink(props),
    CUSTOM_FIELD_TYPE_SELECTION: (props) => renderCustomFieldTypeSelection(props),
    CUSTOM_FIELD_SETTINGS: (props) => renderCustomFieldSettings(props),
    SERIES_PAYMENT_OPTIONS: (props) => renderSeriesPaymentOptionsStep(props),
    CHOOSE_HUG_PAYMENT_TYPE: (props) => renderChoosePaymentOptionsStep(props),
    CHOOSE_TRACK_PAYMENT_OPTIONS: (props) => renderChooseTrackPaymentOptionsStep(props),
    PAYMENT: (props) => renderPayment(props),
    SEND_ONE_TIME_MEMBERSHIP_LINK: (props) => renderSendLink(props),
    PERSONAL_DETAILS: (props) => renderPersonalDetails(props),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: (props) => renderPersonalDetails(props),
    REQUIRED_FIELDS_SETTINGS: (props) => renderRequiredFieldsSettings(props),
    ACCOUNT_CARDS_SETTINGS: (props) => renderAccountCardsSettings(props),
    ORGANIZATION_PRICE_LIST: (props) => renderOrganizationPriceList(props),
    CHOOSE_GROUP_CONNECTION_USER: (props) => renderChooseGroupConnectionUser(props),
    GROUP_CONNECTION_ADD_USER: (props) => renderGroupConnectionAddUser(props),
    SITE_TRIAL_SETTINGS: (props) => renderSiteTrialSettings(props),
    GATES_APPLY_SETTINGS: (props) => renderGatesApplySettings(props),
    GATES_ACTIVITY_HOURS: (props) => renderGatesActivityHours(props),
    SITE_LEAD_FORM_SETTINGS: (props) => renderSiteLeadFormSettings(props),
    ADVANCED_SERIES_SETTINGS: (props) => renderAdvancedSeriesSettings(props),
    EXPORT: (props) => renderExport(props),
    SEND_INVOICES_REPORT: (props) => renderSendInvoicesReport(props),
    SEND_DOCTOR_JOURNAL_REPORT: (props) => renderSendDoctorJournalReport(props),
    NOTE_TEMPLATE: (props) => renderNoteTemplate(props),
    NOTE: (props) => renderNote(props),
    GROUP_DETAILS: (props) => renderGroupDetails(props),
    FLOW_FORM: (props) => renderFlowForm(props),
    FLOW_FORM_CHOICE: (props) => renderFlowFormChoice(props),
    FLOW_FORM_MANAGE: (props) => renderFlowFormManage(props),
    SEND_DEBT_LINK: (props) => renderSendDebtLink(props),
    BUILD_UNIFORM_REPORT: (props) => renderBuildUniformReport(props),
    SEND_CONFIRMATION_LINK: (props) => renderSendConfirmationLink(props),
    BOOK_TO_HUG_CREATE_LEAD: (props) => renderPersonalDetails(props),
    USER_CHARGE_SETTING: (props) => renderUserChargeSetting(props),
    USER_NOTE_EXPORT: (props) => renderUserNoteExport(props),
    PROMO_CODE: (props) => renderPromoCode(props),
    CHOOSE_HUG: (props) => renderChooseHug(props),
    SWAP_TYPE: (props) => renderSwapType(props),
    CHOOSE_SWAP_DAY: (props) => renderChooseSwapDay(props),
    SWAP_DAY_SUMMARY: (props) => renderSwapDaySummary(props),
    CHOOSE_TRACK: (props) => renderChooseTrack(props),
    CHOOSE_TRACK_COURSES: (props) => renderChooseTrackCourses(props),
    BOOKING_TYPE: (props) => renderBookingType(props),
    SEND_ALL_DEBTS_LINK: (props) => renderSendAllDebtsLink(props),
    TRACK_DETAILS: (props) => renderTrackDetailsStep(props),
    TRACK_PAYMENT_OPTIONS: (props) => renderTrackPaymentStep(props),
    TRACK_ADVANCED: (props) => renderTrackAdvancedStep(props),
    TRACK_TIME_CONFIG: (props) => renderTrackTimeConfigStep(props),
    TRACK_EDIT_TIME_CONFIG: (props) => renderTrackEditTimeConfigStep(props),
    TRACK_SETTINGS: (props) => renderTrackSettingsStep(props),
    COURSE_LIMITATIONS: (props) => renderCourseLimitationsStep(props),
    REQUIRED_COURSE_FROM_TRACK: (props) => renderRequiredCourseFromTrackStep(props),
}

export const stepHeader = (props) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const prefix = isEdit ? (flowConfig.editType === SINGLE_SESSION_EDIT_TYPE ? 'edit-a' : 'edit-all') : 'add-a'
    const basicLabel = t(`${prefix}-${flowConfig.selectionsTree[optionalSteps.EVENT_TYPE] ?? 'session'}`)
    const multiDayConfigLabel = flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP] ? t(`${prefix}-${flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]}`) : basicLabel;
    return {
        EVENT_TYPE: t(`${prefix}-session`),
        APPOINTMENT_OR_AVAILABILITY_STEP: basicLabel,
        BASIC_INFO: flowConfig.name === flowOptions.HUGIM_FROM_TRACK_FLOW ? t('create-course-from-track-title') : basicLabel,
        BASIC_INFO_APPOINTMENT: (flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowConfig.name === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY) ? t(`${prefix}-appointment`) : basicLabel,
        REPEAT_CONFIG: basicLabel,
        AVAILABILITY_CONFIG: t(`${prefix}-appointment`),
        MULTI_DAY_CONFIG: flowConfig.name === flowOptions.SPACE_AVAILABILITY ? t('define-space-availability') : multiDayConfigLabel,
        SETTINGS: basicLabel,
        USER_AND_MEMBERSHIP_SELECTION: basicLabel,
        PAYMENT_METHOD_SELECTION: basicLabel,
        SUCCESS_PAGE: null,
        EDIT_MULTI_DAY_CONFIG: flowConfig.name === flowOptions.SPACE_AVAILABILITY ? t(`${prefix}-availability`) : multiDayConfigLabel,
        MEMBER_DETAILS: flowConfig.props.fromEventManage ? t('add-new-lead-event-manage') : t(snakeToCamel(`ADD_NEW_${(flowConfig.name)}`)),
        STAFF_MEMBER_ROLE_SELECT: t('addNewStaffMember'),
        BLOCKED_TIME: t('blocked-time'),
        MESSAGE_TYPE: t('select-message-type'),
        MESSAGE_DETAILS: t('send-message'),
        APPOINTMENT_WAITLIST: t('appointment-waitlist-add-header'),
        EMAIL_AFTER_PURCHASE: t('email-after-purchase-title'),
        DOCUMENTS_AUTO_SEND: t('documentsAutoSendSettingsTitle'),
        SPACE_CONFIGURATION: t('add-space'),
        PENALTY_SETTINGS: flowConfig.props.target ? t('edit-penalty-title') : t('penalty-settings-title'),
        PENALTY_EXTRA_PROPERTIES: t('penalty-extra-properties-title'),
        PENALTY_SUMMARY: t('summary'),
        TASK_DETAILS: flowConfig.props.target?.id ? t('editTaskHeader') : t('addNewTaskHeader'),
        TASK_TYPE: flowConfig.props.target ? t('editTaskType') : t('createTaskType'),
        SEND_CONVERT_LINK: t('send-convert-link-header'),
        CUSTOM_FIELD_TYPE_SELECTION: t(`custom-fields-settings-header-${isEdit ? 'edit' : 'create'}`),
        CUSTOM_FIELD_SETTINGS: t(`custom-fields-settings-header-${isEdit ? 'edit' : 'create'}`),
        SERIES_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}series-payment-options-step-header`),
        CHOOSE_HUG_PAYMENT_TYPE: t('bookHugPaymentTypeHeader'),
        CHOOSE_TRACK_PAYMENT_OPTIONS: t('bookHugPaymentTypeHeader'),
        PAYMENT: flowConfig.name === flowOptions.CLOSE_MU_DEBT ? t('close-debt-step-header') : t('payment-step-header'),
        PERSONAL_DETAILS: t('bookNewMemberToHug'),
        REQUIRED_FIELDS_SETTINGS: t(`required-fields-settings-header${flowConfig.props.initProps?.type !== USER_FIELDS ? (`-${flowConfig.props?.initProps?.type}` ?? '') : ''}`),
        ACCOUNT_CARDS_SETTINGS: t('account-cards-settings-header'),
        ORGANIZATION_PRICE_LIST: t('organization-price-list-header', {name: flowConfig.props.initProps?.target?.name || ''}),
        SEND_ONE_TIME_MEMBERSHIP_LINK: flowConfig.props.target?.showOnlyHugim ? t('send-hug-link-header') : flowConfig.props.target?.fromLeadProfile ? t('send-membership-link-header-lead-profile') : t('send-membership-link-header'),
        CHOOSE_GROUP_CONNECTION_USER: t('choose-group-connection-user-header'),
        GROUP_CONNECTION_ADD_USER: flowConfig?.flags.selection === 'lead'
            ? t('group-connection-add-lead-user-header')
            : t(`${flowConfig.props.target?.groups_id ? 'existing' : 'new'}-group-connection-add${flowConfig?.flags.selection === 'existing' ? '-existing' : ''}-user-header`),
        SITE_TRIAL_SETTINGS: t('site-trial-settings-header'),
        GATES_APPLY_SETTINGS: t('gates-apply-settings-header'),
        GATES_ACTIVITY_HOURS: t('gates-activity-hours-header'),
        LEAD_TO_CONVERT_PERSONAL_DETAILS: t('convertLeadWithHugHeader'),
        SITE_LEAD_FORM_SETTINGS: t('lead-form-site-settings-header'),
        ADVANCED_SERIES_SETTINGS: t(`${isEdit ? 'edit-' : ''}advanced-series-settings-header`),
        EXPORT: t('export-to-foreign-software'),
        SEND_INVOICES_REPORT: t('send-invoices-report-header'),
        SEND_DOCTOR_JOURNAL_REPORT: t('doctorJournalExportTitle'),
        NOTE_TEMPLATE: t(`${isEdit ? 'edit-' : ''}note-template-header`),
        NOTE: getNoteHeader(props),
        GROUP_DETAILS: t('bookNewMemberToHug'),
        FLOW_FORM: t('hugim-form-header', {formName: flowConfig.props.initProps?.form?.name}),
        FLOW_FORM_CHOICE: t('flow-form-connection-choice-header', {formName: flowConfig.props.initProps?.form?.name}),
        FLOW_FORM_MANAGE: t('flow-form-manage-header', {formName: flowConfig.props.initProps?.form?.name}),
        SEND_DEBT_LINK: t('send-debt-link-header'),
        BUILD_UNIFORM_REPORT: t('build-uniform-report-header'),
        SEND_CONFIRMATION_LINK: t('send-confirmation-link-header'),
        BOOK_TO_HUG_CREATE_LEAD: t('create-lead-book-to-hug-header'),
        USER_CHARGE_SETTING: t('user-charge-setting-header'),
        PROMO_CODE: t(`${isEdit ? 'edit' : 'new'}${checkPromoFlowIsInternal(flowConfig.props.initProps, flowConfig.props.target) ? 'Internal' : ''}PromoCode`),
        USER_NOTE_EXPORT: t('user-not-export-header'),
        CHOOSE_HUG: flowConfig.name === flowOptions.HUG_NEW_REGISTRATION ? t('choose-hug-header') : t('choose-hug-to-swap-header'),
        SWAP_TYPE: t('swap-type-header'),
        CHOOSE_SWAP_DAY: t('choose-swap-day-header'),
        SWAP_DAY_SUMMARY: t('swap-day-summary-header'),
        CHOOSE_TRACK: t('choose-track-header'),
        CHOOSE_TRACK_COURSES: t('choose-track-courses-header'),
        BOOKING_TYPE: t('booking-type-header'),
        SEND_ALL_DEBTS_LINK: t('send-all-debts-link-header'),
        TRACK_DETAILS: isEdit ? t('editTrack') : t('addTrack'),
        TRACK_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}track-payment-step-header`),
        TRACK_ADVANCED: t(`${isEdit ? 'edit-' : ''}track-advanced-step-header`),
        TRACK_TIME_CONFIG: t('track-time-step'),
        TRACK_EDIT_TIME_CONFIG: t('edit-track-time-step'),
        TRACK_SETTINGS: t(`${isEdit ? 'edit-' : ''}TRACK_SETTINGS-step`),
        COURSE_LIMITATIONS: t(`${isEdit ? 'edit-' : ''}COURSE_LIMITATIONS-step`),
        REQUIRED_COURSE_FROM_TRACK: t(`REQUIRED_COURSE_FROM_TRACK-step`),
    }
}

const getNoteHeader = (props) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? props.initProps
    const editPrefix = isEdit ? 'edit-' : '';
    const noteType = initProps?.fromCreateEvent ? '' : (initProps?.isSingle || flowConfig.editType === SINGLE_SESSION_EDIT_TYPE ? 'schedule-' : 'series-')
    const noteTypePrefix = flowConfig.name === flowOptions.USER_NOTE ? 'user-' : noteType
    const isEmptySuffix = !initProps?.scheduleType ? '-empty' : ''
    return t(`${editPrefix}${noteTypePrefix}note-header${isEmptySuffix}`, {name: initProps?.scheduleType})
}

export const stepSubHeader = (has, target) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const type = flowConfig.selectionsTree[optionalSteps.EVENT_TYPE]
    const appointmentType = flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]
    let coach = null
    if(flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY) {
        const coachesStore = store.getState().schedule.coaches;
        coach = coachesStore.find(coachStore => coachStore.user_fk === target.coach.user_fk)
    }
    return {
        EVENT_TYPE: t('event-type-step-subheader'),
        APPOINTMENT_OR_AVAILABILITY_STEP: t('one-on-one-subheader'),
        BASIC_INFO: t(`basic-info-step-subheader${isEdit ? '-edit' : ''}`, {type: t((type === 'hugim' ? 'courses' : type) + '-label')}),
        BASIC_INFO_APPOINTMENT: t(`basic-info-step-subheader${isEdit ? '-edit' : ''}`, {type: t(((flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowConfig.name === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY) ? 'appointment' : type) + '-label')}),
        REPEAT_CONFIG: t(`repeat-config-step-subheader${isEdit ? '-edit' : ''}`),
        AVAILABILITY_CONFIG: coach ? t('availability-config-step-subheader-with-sync') : t('availability-config-step-subheader'),
        MULTI_DAY_CONFIG: t(`multi-day-config-step-subheader-${appointmentType ?? type}`),
        SETTINGS: t('settings-step-subheader'),
        USER_AND_MEMBERSHIP_SELECTION: t('user-and-membership-step-subheader'),
        PAYMENT_METHOD_SELECTION: t('payment-method-step-subheader'),
        SUCCESS_PAGE: null,
        EDIT_MULTI_DAY_CONFIG: t(`edit-multi-day-config-step-subheader-${flowConfig.name === flowOptions.SPACE_AVAILABILITY ? 'space' : appointmentType ?? type}`),
        MEMBER_DETAILS: '',
        STAFF_MEMBER_ROLE_SELECT: t('addNewStaffMemberRolesInfo'),
        BLOCKED_TIME: '',
        MESSAGE_TYPE: t('select-message-type-subheader'),
        MESSAGE_DETAILS: '',
        APPOINTMENT_WAITLIST: t('appointment-waitlist-add-subheader'),
        EMAIL_AFTER_PURCHASE: t('email-after-purchase-info'),
        DOCUMENTS_AUTO_SEND: t('documentsAutoSendSettingsSubtitle'),
        SPACE_CONFIGURATION: t('add-space-subheader'),
        PENALTY_SETTINGS: t('penalty-settings-subtitle'),
        PENALTY_EXTRA_PROPERTIES: t('penalty-extra-properties-subtitle'),
        PENALTY_SUMMARY: '',
        TASK_DETAILS: '',
        SEND_CONVERT_LINK: t('send-convert-link-subheader'),
        CUSTOM_FIELD_TYPE_SELECTION: t(`custom-fields-add-subheader`),
        CUSTOM_FIELD_SETTINGS: t(`custom-fields-settings-subheader-${isEdit ? 'edit' : 'create'}`),
        SERIES_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}series-payment-options-step-subheader`),
        CHOOSE_HUG_PAYMENT_TYPE: t('bookHugPaymentTypeSubheader'),
        CHOOSE_TRACK_PAYMENT_OPTIONS: t('bookHugPaymentTypeSubheader'),
        SEND_ONE_TIME_MEMBERSHIP_LINK: flowConfig.props.target?.showOnlyHugim ? t('hugim-purchase-leads') : (flowConfig.props.target?.fromLeadProfile ? t('send-membership-link-subheader-leads') : (has('hugim') ? t('send-membership-link-subheader-hugim') : t('send-membership-link-subheader'))),
        PERSONAL_DETAILS: t('bookNewMemberToHugSubheader'),
        TASK_TYPE: '',
        REQUIRED_FIELDS_SETTINGS: t(`required-fields-settings-subheader${flowConfig.props.initProps?.type !== USER_FIELDS ? (`-${flowConfig.props?.initProps?.type}` ?? '') : ''}`),
        ACCOUNT_CARDS_SETTINGS: null,
        ORGANIZATION_PRICE_LIST: t('organization-price-list-subheader'),
        CHOOSE_GROUP_CONNECTION_USER: t('choose-group-connection-user-subheader'),
        GROUP_CONNECTION_ADD_USER: flowConfig?.flags.selection === 'lead'
            ? t('group-connection-add-lead-user-subheader')
            : t(`group-connection-add${flowConfig?.flags.selection === 'existing' ? '-existing' : ''}-user-subheader`),
        SITE_TRIAL_SETTINGS: t('site-trial-settings-subheader'),
        GATES_APPLY_SETTINGS: t('gates-apply-settings-subheader'),
        GATES_ACTIVITY_HOURS: t('gates-activity-hours-subheader'),
        LEAD_TO_CONVERT_PERSONAL_DETAILS: t('convertLeadWithHugSubheader'),
        SITE_LEAD_FORM_SETTINGS: t('lead-form-site-settings-subheader'),
        ADVANCED_SERIES_SETTINGS: t(`${isEdit ? 'edit-' : ''}advanced-series-settings-subheader`),
        SEND_INVOICES_REPORT: t('send-invoices-report-subheader', {dateRange: flowConfig.props.dates?.replace(/\./g, '/')}),
        SEND_DOCTOR_JOURNAL_REPORT: null,
        NOTE_TEMPLATE: null,
        NOTE: null,
        GROUP_DETAILS: t('bookGroupToHugSubheader'),
        FLOW_FORM: t('hugim-form-subheader'),
        FLOW_FORM_CHOICE: null,
        FLOW_FORM_MANAGE: t('flow-form-manage-subheader'),
        BUILD_UNIFORM_REPORT: t('build-uniform-report-subheader'),
        SEND_DEBT_LINK: t(`send-debt-link-subheader${flowConfig.props?.target?.type === 'reports' ? '-reports' : ''}`),
        SEND_CONFIRMATION_LINK: t('send-confirmation-link-subheader'),
        BOOK_TO_HUG_CREATE_LEAD: t('create-lead-details-subheader'),
        USER_CHARGE_SETTING: t('user-charge-setting-subheader'),
        PROMO_CODE: t(`${isEdit ? 'edit' : 'new'}${checkPromoFlowIsInternal(flowConfig.props.initProps, flowConfig.props.target) ? 'Internal' : ''}PromoCodeSubHeader`),
        USER_NOTE_EXPORT: t('user-not-export-subheader'),
        CHOOSE_HUG: flowConfig.name === flowOptions.HUG_NEW_REGISTRATION ? t('choose-hug-subheader') : t('choose-hug-to-swap-subheader'),
        SWAP_TYPE: t('swap-type-subheader'),
        SWAP_DAY_SUMMARY: t('swap-day-summary-subheader'),
        CHOOSE_TRACK: t('choose-track-subheader'),
        CHOOSE_TRACK_COURSES: t('choose-track-courses-subheader'),
        BOOKING_TYPE: t('booking-type-subheader'),
        SEND_ALL_DEBTS_LINK: t('send-all-debts-link-subheader'),
        TRACK_DETAILS: t(`${isEdit ? 'edit-' : ''}TRACK_DETAILS-step-subheader`),
        TRACK_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}TRACK_PAYMENT_OPTIONS-step-subheader`),
        TRACK_ADVANCED: t(`${isEdit ? 'edit-' : ''}TRACK_ADVANCED-step-subheader`),
        TRACK_TIME_CONFIG: t(`${isEdit ? 'edit-' : ''}TRACK_TIME_CONFIG-step-subheader`),
        TRACK_EDIT_TIME_CONFIG: t(`${isEdit ? 'edit-' : ''}TRACK_EDIT_TIME_CONFIG-step-subheader`),
        TRACK_SETTINGS: t(`${isEdit ? 'edit-' : ''}TRACK_SETTINGS-step-subheader`),
        COURSE_LIMITATIONS: t(`${isEdit ? 'edit-' : ''}COURSE_LIMITATIONS-step-subheader`),
        REQUIRED_COURSE_FROM_TRACK: t(`REQUIRED_COURSE_FROM_TRACK-step-subheader`),
    }
}

export const shouldConsiderInProgressBar = () => {
    const flowConfig = store.getState().stepper
    return {
        EVENT_TYPE: false,
        APPOINTMENT_OR_AVAILABILITY_STEP: false,
        BASIC_INFO: true,
        BASIC_INFO_APPOINTMENT: true,
        REPEAT_CONFIG: true,
        AVAILABILITY_CONFIG: true,
        MULTI_DAY_CONFIG: true,
        SETTINGS: true,
        USER_AND_MEMBERSHIP_SELECTION: true,
        PAYMENT_METHOD_SELECTION: false,
        SUCCESS_PAGE: false,
        EDIT_MULTI_DAY_CONFIG: true,
        MEMBER_DETAILS: false,
        STAFF_MEMBER_ROLE_SELECT: false,
        BLOCKED_TIME: false,
        MESSAGE_TYPE: false,
        MESSAGE_DETAILS: false,
        APPOINTMENT_WAITLIST: false,
        EMAIL_AFTER_PURCHASE: false,
        DOCUMENTS_AUTO_SEND: false,
        SPACE_CONFIGURATION: false,
        CUSTOM_FIELD_TYPE_SELECTION: false,
        CUSTOM_FIELD_SETTINGS: false,
        SERIES_PAYMENT_OPTIONS: true,
        CHOOSE_HUG_PAYMENT_TYPE: ![flowOptions.SWAP_HUG_REGISTRATION, flowOptions.HUG_NEW_REGISTRATION].includes(flowConfig.name),
        CHOOSE_TRACK_PAYMENT_OPTIONS: true,
        PAYMENT: true,
        PERSONAL_DETAILS: true,
        LEAD_TO_CONVERT_PERSONAL_DETAILS: true,
        ADVANCED_SERIES_SETTINGS: true,
        NOTE_TEMPLATE: false,
        NOTE: false,
        GROUP_DETAILS: true,
        FLOW_FORM: false,
        FLOW_FORM_CHOICE: false,
        FLOW_FORM_MANAGE: false,
        BOOK_TO_HUG_CREATE_LEAD: true,
        CHOOSE_HUG: true,
        SWAP_TYPE: false,
        CHOOSE_SWAP_DAY: true,
        SWAP_DAY_SUMMARY: true,
        CHOOSE_TRACK: true,
        CHOOSE_TRACK_COURSES: true,
        BOOKING_TYPE: true,
        TRACK_DETAILS: true,
        TRACK_PAYMENT_OPTIONS: true,
        TRACK_ADVANCED: true,
        TRACK_TIME_CONFIG: true,
        TRACK_EDIT_TIME_CONFIG: true,
        TRACK_SETTINGS: true,
        COURSE_LIMITATIONS: true,
        REQUIRED_COURSE_FROM_TRACK: true,
    }
}

export const showProgressBar = ({
    EVENT_TYPE: false,
    APPOINTMENT_OR_AVAILABILITY_STEP: false,
    BASIC_INFO: true,
    BASIC_INFO_APPOINTMENT: true,
    REPEAT_CONFIG: true,
    AVAILABILITY_CONFIG: true,
    MULTI_DAY_CONFIG: true,
    SETTINGS: true,
    USER_AND_MEMBERSHIP_SELECTION: true,
    PAYMENT_METHOD_SELECTION: true,
    SUCCESS_PAGE: false,
    EDIT_MULTI_DAY_CONFIG: true,
    MEMBER_DETAILS: false,
    STAFF_MEMBER_ROLE_SELECT: false,
    BLOCKED_TIME: false,
    MESSAGE_TYPE: false,
    MESSAGE_DETAILS: false,
    APPOINTMENT_WAITLIST: false,
    EMAIL_AFTER_PURCHASE: false,
    DOCUMENTS_AUTO_SEND: false,
    SPACE_CONFIGURATION: false,
    CUSTOM_FIELD_TYPE_SELECTION: false,
    CUSTOM_FIELD_SETTINGS: false,
    SERIES_PAYMENT_OPTIONS: true,
    CHOOSE_HUG_PAYMENT_TYPE: true,
    CHOOSE_TRACK_PAYMENT_OPTIONS: true,
    PAYMENT: true,
    PERSONAL_DETAILS: true,
    LEAD_TO_CONVERT_PERSONAL_DETAILS: true,
    ADVANCED_SERIES_SETTINGS: true,
    EXPORT: false,
    SEND_INVOICES_REPORT: false,
    SEND_DOCTOR_JOURNAL_REPORT: false,
    NOTE_TEMPLATE: false,
    NOTE: false,
    GROUP_DETAILS: true,
    FLOW_FORM: false,
    BOOK_TO_HUG_CREATE_LEAD: true,
    CHOOSE_HUG: true,
    SWAP_TYPE: false,
    CHOOSE_SWAP_DAY: true,
    SWAP_DAY_SUMMARY: true,
    CHOOSE_TRACK: true,
    CHOOSE_TRACK_COURSES: true,
    BOOKING_TYPE: true,
    TRACK_DETAILS: true,
    TRACK_PAYMENT_OPTIONS: true,
    TRACK_ADVANCED: true,
    TRACK_TIME_CONFIG: true,
    TRACK_EDIT_TIME_CONFIG: true,
    TRACK_SETTINGS: true,
    COURSE_LIMITATIONS: true,
    REQUIRED_COURSE_FROM_TRACK: true,
})

export const overrideCurrentValues = (stepName) => {
    const flowConfig = store.getState().stepper
    switch (stepName) {
        case optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP:
        case optionalSteps.EVENT_TYPE:
            return false
        case optionalSteps.SETTINGS:
        case optionalSteps.TRACK_SETTINGS:
            return flowConfig.flags.overrideValues ? false : true
        default:
            return true
    }
}

export const stepValidationSchema = () => ({
    EVENT_TYPE: yup.object().shape({}),
    BASIC_INFO: getBasicInfoValidationSchema(),
    BASIC_INFO_APPOINTMENT: getBasicInfoAppointmentValidationSchema(),
    REPEAT_CONFIG: getRepeatConfigValidationSchema(),
    AVAILABILITY_CONFIG: getAvailabilityConfigValidationSchema(),
    MULTI_DAY_CONFIG: getMultiDayConfigValidationSchema(),
    SETTINGS: yup.object().shape({
        transparent: yup.boolean().required(t('thisFieldIsMandatory')),
        disable_cancellation_time: yup.number().min(0).required(t('thisFieldIsMandatory')),
        enable_late_cancellation: yup.boolean().required(t('thisFieldIsMandatory')),
        cancel_limit: yup.number().nullable(),
        min_users: yup.number().integer().nullable(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        live_link: yup.string().nullable(),
        gender: yup.string().nullable().oneOf(['male', 'female', null]),
        min_age: yup.number().min(0, t('thisFieldIsMandatory')).nullable().typeError(t('thisFieldIsMandatory'))
            .when('max_age', (max_age, schema) => max_age ? schema.required(t('thisFieldIsMandatory')) : schema),
        max_age: yup.number().nullable().typeError(t('thisFieldIsMandatory'))
            .test('max-age-greater', t('session-age-end-after-start'), function (max_age) {
                const {min_age} = this.parent
                if (max_age === null || max_age === undefined) return true
                return min_age != null && max_age > min_age
            }),
        register_group_member: yup.boolean().required(t('thisFieldIsMandatory')),
        allow_mid_booking: yup.boolean().required(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().when(['enable_registration_time'], (enable_registration_time, schema) => {
            return schema.test({
                test: blockRegistrationTime => blockRegistrationTime < enable_registration_time || blockRegistrationTime === 0 || enable_registration_time === 0,
                message: t('enableRegistrationSmallerOrEqualToBlock')
            })
        }),
        enable_registration_time: yup.number(),
        paymentOptions: yup.array(getPaymentOptionValidationSchema(null, true)).nullable()
    }),
    USER_AND_MEMBERSHIP_SELECTION: getUserAndMembershipValidationSchema(),
    PAYMENT_METHOD_SELECTION: yup.object().shape({}),
    SUCCESS_PAGE: yup.object().shape({}),
    EDIT_MULTI_DAY_CONFIG: getEditMultiDaysValidationSchema(),
    MEMBER_DETAILS: getUserDetailsBaseValidationSchema(),
    STAFF_MEMBER_ROLE_SELECT:  yup.object().shape({
        roles: yup.array(yup.string()).min(1, t('staff-roles-choose-at-least-one'))
    }),
    BLOCKED_TIME: getBlockedTimeValidationSchema(),
    MESSAGE_TYPE: yup.object().shape({
        type: yup.string().required(t('thisFieldIsMandatory')).oneOf([PUSH, SMS, EMAIL, WHATSAPP])
    }),
    MESSAGE_DETAILS: getMessageDetailsValidationSchema(),
    APPOINTMENT_WAITLIST: getAppointmentWaitlistAddValidationSchema(),
    EMAIL_AFTER_PURCHASE: yup.object().shape({
        locations_box_id: yup.number().required(),
        membership_types: yup.array(yup.object().shape({
            id: yup.number().required()
        })).test('memberships', t('select-at-least-one-membership'), function (value) {
            return value?.filter?.(mt => mt.location_box_fk == this.parent.locations_box_id)?.length > 0 || this.parent.trial_class
        }),
        users_boxes: yup.array(yup.object().shape({
            id: yup.number().required()
        })).min(1, t('select-at-least-one-staff-member')),
        trial_class: yup.boolean()
    }),
    DOCUMENTS_AUTO_SEND: yup.object().shape({
        rivhit_id: yup.string().required(),
        send_customer_tax_invoice_receipt: yup.boolean(),
        send_customer_payment_receipt: yup.boolean(),
        send_customer_tax_invoice: yup.boolean(),
        confirmed: yup.boolean(),
    }),
    SPACE_CONFIGURATION: getSpaceConfigValidationSchema(),
    PENALTY_SETTINGS: getPenaltiesSettingsValidationSchema(),
    PENALTY_EXTRA_PROPERTIES: getExtraPenaltiesPropertiesValidationSchema(),
    TASK_DETAILS: yup.object().shape({
        reminder_time: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        user_fk: yup.number().integer().nullable().when('targeted', {
            is: value => value === targetAudienceTasks.SPECIFIC_USER,
            then: yup.number().min(1).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        task_type_fk: yup.number().integer().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        assigned_to: yup.number().integer().nullable(),
        description: yup.string().test('no-emojis', t('no-emojis-are-allowed-task-desc'), isStringWithoutEmoji),
        locations_box_fk: yup.number().integer().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        done: yup.boolean().nullable(),
        targeted: yup.string(),
        check_in: yup.boolean(),
        access_control: yup.boolean(),
        is_personal: yup.number()
    }),
    TASK_TYPE: yup.object().shape({
        type: yup.string().required(),
        check_in: yup.boolean(),
        access_control: yup.boolean(),
        task_type_color: yup.string()

    }),
    SEND_CONVERT_LINK: getSendConvertLinkValidationSchema(),
    CUSTOM_FIELD_TYPE_SELECTION: yup.object().shape({customFieldType: yup.string().required().oneOf([SCHEDULE_TYPE, USER_TYPE])}),
    CUSTOM_FIELD_SETTINGS: yup.object().shape({
        customFieldName: yup.string()
            .required(t('thisFieldIsMandatory'))
            .typeError(t('thisFieldIsMandatory'))
            .min(2, t('customFieldNameMinMaxError'))
            .max(30, t('customFieldNameMinMaxError'))
            .test(
                'unique-name',
                t('nameAlreadyExistsError'),
                (value) =>  {
                    const target = store.getState().stepper.props?.target;
                    const originalField = target ? {id: target.custom_field_id, name: target.customFieldName} : null;
                    const customFieldsNames = store.getState().schedule.scheduleCustomFields?.filter(field => originalField ? originalField.id !== field.custom_field_id : field).map(field => field.custom_field_name);
                    return !customFieldsNames?.includes(value);
                }
            ),
        inputType: yup.string().when('customFieldType', {
            is: value => value === SCHEDULE_TYPE,
            then: yup.string().required(t('thisFieldIsMandatory')).oneOf([customFieldTypes.SELECT]),
            otherwise: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        locations: yup.array().min(1, t('mustChooseAtLeastOneLocationError')).required(),
        flows: yup.array()
            .min(1, t('mustChooseAtLeastOneFlowError'))
            .test('at-least-one-checked', t('mustChooseAtLeastOneFlowError'), function(value) {
                return value?.some(flow => flow.checked === true);
            })
            .required(),
        props: yup.object().when('inputType', {
            is: customFieldTypes.SELECT,
            then: yup.object().shape({
                options: yup.array(yup.object().shape({
                    value: yup.string().required(t('thisFieldIsMandatory'))
                })).min(2, t('mustSetAtLeastTwoOptionsError')).required()
            }),
            otherAttribute: yup.mixed().test(
                'has-min-options',
                t('mustSetAtLeastTwoOptionsError'),
                function(value) {
                    const { options } = this.parent;
                    return options && options.length >= 2;
                }
            )
        })
    }),
    SERIES_PAYMENT_OPTIONS: yup.object().shape({
        paymentOptions: yup.array(getPaymentOptionValidationSchema(null, true).concat(yup.object().shape({
            relative_payment: yup.string().oneOf([RELATIVE, FULL, null]).nullable(),
            income_card: yup.number().nullable(),
            edited_price_per_session: yup.number().nullable().min(0),
            }))),
        sort_code: yup.number().nullable().min(100, t('sort-code-must-have-3-digits')).max(999, t('sort-code-must-have-3-digits')),
        sku: yup.number().nullable(),
    }),
    ADVANCED_SERIES_SETTINGS: yup.object().shape({
        paymentOptions: yup.array(getPaymentOptionValidationSchema(null, true).concat(
            yup.object().shape({
                addons: yup.array().of(yup.number()).ensure(),
                upsell: getUpsellValidationSchema(),
            })
        )),
        partialOptions: yup.array().when(['multiDayConfig', 'days'], (multiDayConfig, days) => {
            const daysArray = multiDayConfig?.days ?? days ?? []
            if(daysArray?.length > 1) {
                return yup.array(getPaymentOptionValidationSchema([HOK, IMMEDIATE], true).concat(yup.object().shape({
                    daysOfWeek: yup.number().integer().min(1).max((daysArray?.length - 1) || 1),
                    name: yup.string().required(t('thisFieldIsMandatory')),
                    edited_price_per_session: yup.number().nullable().min(0),
                })))
            }
            else return yup.array().nullable()
        }),
        form_id: yup.number().nullable()
    }),
    CHOOSE_HUG_PAYMENT_TYPE: yup.object().shape({
        cart: yup.array().of(yup.object().shape({
            id: yup.number().required(t('selectPaymentTypeError')).typeError(t('selectPaymentTypeError')),
        }))
    }),
    PAYMENT: yup.object().shape({
        payment_info: yup.object().required(),
    }),
    PERSONAL_DETAILS: getUserDetailsBaseValidationSchema('member'),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: getUserDetailsBaseValidationSchema('member'),
    REQUIRED_FIELDS_SETTINGS: getRequiredFieldsSettingsValidationSchema(),
    ACCOUNT_CARDS_SETTINGS: getAccountCardsSettingsValidationSchema(),
    ORGANIZATION_PRICE_LIST: getOrganizationPriceListValidationSchema(),
    SEND_ONE_TIME_MEMBERSHIP_LINK: getSendMembershipLinkValidationSchema(),
    CHOOSE_GROUP_CONNECTION_USER: yup.object().shape({
        selection: yup.string().required().oneOf(['existing', 'new', 'lead'])
    }),
    GROUP_CONNECTION_ADD_USER: getGroupConnectionAddUserValidationSchema(),
    SITE_TRIAL_SETTINGS: yup.object().shape({
        newLead: yup.object().shape({
            status_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            source_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        existingLead: yup.object().shape({
            status_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
            source_id: yup.number().nullable().typeError(t('thisFieldIsMandatory'))
        })
    }),
    GATES_APPLY_SETTINGS: yup.object().shape({
        apply: yup.string().oneOf(['all', 'each'])
    }),
    GATES_ACTIVITY_HOURS: yup.object().shape({}),
    SITE_LEAD_FORM_SETTINGS: siteLeadFormSettingsValidationSchema(),
    EXPORT: getExportValidationSchema(),
    SEND_INVOICES_REPORT: getSendInvoicesValidationSchema(),
    SEND_DOCTOR_JOURNAL_REPORT: getSendDoctorJournalReportValidationSchema(),
    NOTE_TEMPLATE: yup.object().shape({
        name: yup.string().required(t('thisFieldIsMandatory')).max(40, t('field-string-length-error', {length: '40'})),
        content: yup.string().required(t('thisFieldIsMandatory')).test(
            'has-content',
            t('thisFieldIsMandatory'),
            (value) => {
                if (!value) return false;
                const textOnly = value.replace(/<[^>]*>/g, '').trim();
                return textOnly !== '';
            }
        ),
        scope: yup.string().required().oneOf([messageTemplateScopes.NOTE]),
        id: yup.number().nullable()
    }),
    NOTE: getNoteValidationSchema(),
    GROUP_DETAILS: yup.object().shape({
        isChildRegistration: yup.boolean(),
        headType: yup.string(),
        child: courseChildDetailsValidationSchema(),
        parent: yup.object().when(['isChildRegistration', 'headType'], {
            is: (isChildRegistration, headType) => isChildRegistration === true && headType === HEAD_TYPES.EXISTING,
            then: yup.object().shape({
                id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            }),
            otherwise: yup.object().when(['isChildRegistration', 'headType'], {
                is: (isChildRegistration, headType) => isChildRegistration === true && headType === HEAD_TYPES.NEW,
                then: getUserDetailsBaseValidationSchema('member'),
                otherwise: yup.object()
            })
        })
    }),
    FLOW_FORM: yup.object().shape({
        hugimType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            hugim: yup.array().of(yup.number()),
            allowTrial: yup.boolean(),
        }),
        groupType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            box_categories: yup.array().of(yup.number()),
            allowTrial: yup.boolean(),
        }),
        appointmentType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            box_categories: yup.array().of(yup.number()),
            allowTrial: yup.boolean(),
        })
    }),
    FLOW_FORM_CHOICE: yup.object().shape({
        flowFormConnectionType: yup.string().required(),
    }),
    FLOW_FORM_MANAGE: yup.object().shape({
        appointmentType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            displayMode: yup.string().oneOf(['none', 'all', 'specific']).required(),
            box_categories: yup.array().of(yup.number()).when('displayMode', {
                is: DISPLAY_MODE_SPECIFIC,
                then: schema => schema.min(1, t('thisFieldIsMandatory')),
                otherwise: schema => schema,
            }),
        }),
    }),
    SEND_DEBT_LINK: getDebtLinkValidationSchema(),
    BUILD_UNIFORM_REPORT: getBuildUniformReportValidationSchema(),
    SEND_CONFIRMATION_LINK: getConfirmationLinkValidationSchema(),
    BOOK_TO_HUG_CREATE_LEAD: getUserDetailsBaseValidationSchema('lead'),
    USER_CHARGE_SETTING: getUserChargeSettingValidationSchema(),
    PROMO_CODE: getPromoCodeValidationSchema(),
    USER_NOTE_EXPORT: getUserNoteExportValidationSchema(),
    CHOOSE_HUG: yup.object().shape({
        eventData: yup.object().shape({
            series: yup.object().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            date: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        })
    }),
    SWAP_TYPE: yup.object().shape({}),
    CHOOSE_SWAP_DAY: yup.object().shape({
        fromSeriesEventId: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        toSeriesEventId: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
    }),
    SWAP_DAY_SUMMARY: yup.object().shape({}),
    CHOOSE_TRACK: yup.object(),
    CHOOSE_TRACK_COURSES: yup.object(),
    BOOKING_TYPE: yup.object().shape({
        bookingType: yup.string().required(t('thisFieldIsMandatory')),
        selectedSeriesEvents: yup.array().of(yup.number()).nullable()
            .when('bookingType', (bookingType, schema) => {
                if (bookingType?.startsWith(HUG_PARTIAL_BOOKING)) {
                    const requiredCount = parseInt(bookingType.split('_').pop(), 10);
                    return schema
                        .required(t('thisFieldIsMandatory'))
                        .typeError(t('thisFieldIsMandatory'))
                        .length(requiredCount, t('thisFieldIsMandatory'));
                }
                return schema.length(0, t('thisFieldIsMandatory'));
            }),
        cancelReasonId: store.getState().stepper.name === flowOptions.SWAP_HUG_REGISTRATION
            ? yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
            : yup.number().nullable()
    }),
    SEND_ALL_DEBTS_LINK: getAllDebtsLinkValidationSchema(),
    TRACK_DETAILS: yup.object().shape({
        name: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        bio: yup.string().max(1000, t('field-string-length-error', {length: '1000'})).nullable(),
        start_date: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value;
        }),
        end_date: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')).when(['start_date'], (start_date, schema) => {
            const start = moment(start_date, dbDateFormat);
            return schema.test({
                test: end => moment(end, dbDateFormat).isAfter(start),
                message: t('end-date-error'),
            });
        }).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value;
        }),
        locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        session_per_week: yup.number().integer().min(1).max(20).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        department_id: yup.number().nullable(),
    }),
    TRACK_PAYMENT_OPTIONS: yup.object().shape({
        paymentOptions: yup.array(yup.object().shape({
            type: yup.string().oneOf([HOK, IMMEDIATE]),
            relative_payment: yup.string().oneOf([TRACK_RELATIVE, TRACK_FULL, TRACK_HALF]).nullable(),
            show_in_app: yup.number().integer().min(0).max(3),
            max_installments: yup.number().integer().min(1).max(24).typeError(t('thisFieldIsMandatory')),
            price: yup.number().when('type', {
                is: type => type === HOK,
                then: yup.number().min(1, t('price-zero-invalid')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                otherwise: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
            }),
            taxes: yup.array().of(yup.number().required(t('thisFieldIsMandatory'))).ensure(),
        })),
        sort_code: yup.number().nullable().min(100, t('sort-code-must-have-3-digits')).max(999, t('sort-code-must-have-3-digits')),
        sku: yup.number().nullable(),
    }),
    TRACK_ADVANCED: yup.object().shape({
        paymentOptions: yup.array(yup.object().shape({
            type: yup.string().oneOf([HOK, IMMEDIATE]),
            addons: yup.array().of(yup.number()).ensure()
        })).nullable(),
        register_group_member: yup.boolean().required(t('thisFieldIsMandatory')),
        allow_mid_booking: yup.boolean().required(t('thisFieldIsMandatory')),
    }),
    COURSE_LIMITATIONS: yup.object().shape({
        courses: yup.array().of(yup.object().shape({
            series_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            session_per_week: yup.number().integer().min(1).max(7).nullable(),
        })).nullable(),
    }),
    REQUIRED_COURSE_FROM_TRACK: yup.object().shape({
        series_event_ids: yup.array().of(yup.number()).nullable(),
    }),
    TRACK_TIME_CONFIG: getMultiDayConfigValidationSchema(),
    TRACK_EDIT_TIME_CONFIG: getEditMultiDaysValidationSchema(),
    TRACK_SETTINGS: yup.object().shape({
        live_link: yup.string().nullable(),
        paymentOptions: yup.array(getPaymentOptionValidationSchema([TRIAL], true)).nullable(),
    }),
    CHOOSE_TRACK_PAYMENT_OPTIONS: yup.object().shape({
        cart: yup.array().of(yup.object().shape({
            id: yup.number().required(t('selectPaymentTypeError')).typeError(t('selectPaymentTypeError')),
        }))
    })
})

export const stepInitialValues = ({eventDateTime, target, initProps}) => {
    const selectedTime = eventDateTime?.start ?? moment().startOf('hour').format(dbTimeFormat)
    const selectedDay = eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).day() : moment().day()
    const flowName = store.getState().stepper.name
    const defaultLocation = store.getState().user.user.locations_box_fk
    const editType = store.getState().stepper?.editType
    const messageTypeDefault = target?.selectedType || ((target?.type === 'reports') && (target?.messageTypes?.includes(PUSH) ? PUSH : SMS)) || PUSH

    return {
        EVENT_TYPE: {},
        BASIC_INFO: getBasicInfoInitialValues(target, initProps),
        BASIC_INFO_APPOINTMENT: getBasicInfoAppointmentInitialValues(target, initProps, eventDateTime, selectedDay, selectedTime),
        REPEAT_CONFIG: getRepeatInitialValues(target, eventDateTime, selectedTime, selectedDay, flowName),
        AVAILABILITY_CONFIG: getAvailabilityConfigInitialValues(target, eventDateTime, selectedDay),
        MULTI_DAY_CONFIG: getMultiDayConfigInitialValues(eventDateTime, selectedDay, initProps),
        SETTINGS: getSettingsInitialValues(target),
        USER_AND_MEMBERSHIP_SELECTION: getUserAndMembershipInitialValues(target, initProps),
        PAYMENT_METHOD_SELECTION: {},
        SUCCESS_PAGE: {},
        EDIT_MULTI_DAY_CONFIG: getEditMultiDaysInitialValues(eventDateTime, target),
        MEMBER_DETAILS: getUserDetailsBaseInitialValues(target),
        STAFF_MEMBER_ROLE_SELECT: {
            roles: initProps?.roles ?? store.getState().stepper?.props?.initProps?.roles ?? [] // tbh i dont like it, but initProps is not correct
        },
        BLOCKED_TIME: {
            scheduleTarget: target ?? null,
            coach_fk: target?.coach_fk ?? initProps?.coach_fk ?? null,
            locations_box_fk: target?.locations_box_fk ?? null,
            place: target?.place ?? '',
            spaces_id: target?.spaces_id ?? initProps?.spaces_id ?? null,
            ...getRepeatInitialValues(target, eventDateTime, selectedTime, selectedDay, flowName),
        },
        MESSAGE_TYPE: {
            type: messageTypeDefault,
            targetType: target?.type || null
        },
        MESSAGE_DETAILS: {
            message_template_id: null,
            type: messageTypeDefault,
        },
        EMAIL_AFTER_PURCHASE: getEmailAfterPurchaseInitialValues(target),
        DOCUMENTS_AUTO_SEND: getDocumentsAutoSendInitialValues(target),
        SPACE_CONFIGURATION: {
            locations_box_id: null,
            name: '',
            availabilityInfo: null
        },
        PENALTY_SETTINGS: getPenaltySettingsInitialValues(target),
        PENALTY_EXTRA_PROPERTIES: getPenaltyExtraPropertiesInitialValues(target),
        TASK_DETAILS: getTaskDetailsInitialValues(target),
        TASK_TYPE: getCreateTaskTypeInitialValues(target),
        SEND_CONVERT_LINK: getSendConvertLinkInitialValues(target),
        CUSTOM_FIELD_TYPE_SELECTION: {customFieldType: USER_TYPE},
        CUSTOM_FIELD_SETTINGS: getCustomFieldSettingsInitialValues(target),
        SERIES_PAYMENT_OPTIONS: getSeriesPaymentOptionsInitialValues(target),
        CHOOSE_HUG_PAYMENT_TYPE: { cart: null},
        PAYMENT: {payment_info: null},
        PERSONAL_DETAILS: getUserDetailsBaseInitialValues(target),
        REQUIRED_FIELDS_SETTINGS: getRequiredFieldsSettingsInitialValues(initProps),
        ACCOUNT_CARDS_SETTINGS: getAccountCardsSettingsInitialValues(),
        ORGANIZATION_PRICE_LIST: getOrganizationPriceListInitialValues(initProps),
        SEND_ONE_TIME_MEMBERSHIP_LINK: getSendMembershipLinkInitialValues(target),
        CHOOSE_GROUP_CONNECTION_USER: {selection: 'existing'},
        LEAD_TO_CONVERT_PERSONAL_DETAILS: getUserDetailsBaseInitialValues(target),
        GROUP_CONNECTION_ADD_USER: getGroupConnectionAddUserInitialValues(target),
        SITE_TRIAL_SETTINGS: getSiteTrialSettingsInitialValues(),
        GATES_APPLY_SETTINGS: {apply: 'all'},
        GATES_ACTIVITY_HOURS: getGatesActivityHoursInitialValues(),
        SITE_LEAD_FORM_SETTINGS: getLeadFormSiteSettingsInitialValues(),
        ADVANCED_SERIES_SETTINGS: getSeriesPartialOptionsInitialValues(target),
        EXPORT: getExportInitialValues(),
        SEND_INVOICES_REPORT: getSendInvoicesReportInitialValues(),
        SEND_DOCTOR_JOURNAL_REPORT: getSendDoctorJournalReportInitialValues(initProps),
        NOTE_TEMPLATE: {
            id: target?.id ?? null,
            name: target?.name ?? '',
            content: target?.text ?? '',
            scope: messageTemplateScopes.NOTE
        },
        NOTE: getNoteInitialValues({target, ogInitProps: initProps}),
        GROUP_DETAILS: {
            child: getUserDetailsBaseInitialValues(target, true),
            parent: getUserDetailsBaseInitialValues(target, false, true),
            locations_box_fk: defaultLocation,
            isChildRegistration: true,
            headType: HEAD_TYPES.NEW,
        },
        FLOW_FORM: getFlowFormInitialValues({target, ogInitProps: initProps}),
        FLOW_FORM_CHOICE: {flowFormConnectionType: 'site'},
        FLOW_FORM_MANAGE: getFlowFormManageInitialValues({ogInitProps: initProps}),
        SEND_DEBT_LINK: getDebtLinkInitialValues({target, initProps}),
        BUILD_UNIFORM_REPORT: {
            report_type: 'tax_year',
            tax_year: null,
            from_date: null,
            to_date: null,
            location_box: null,
        },
        SEND_CONFIRMATION_LINK: getSendConfirmationLinkInitialValues({target, initProps}),
        BOOK_TO_HUG_CREATE_LEAD: getUserDetailsBaseInitialValues(target),
        USER_CHARGE_SETTING: getUserChargeSettingInitialValues(initProps),
        USER_NOTE_EXPORT: getUserNoteExportInitialValues({target}),
        CHOOSE_HUG: {
            eventData: null
        },
        SWAP_TYPE: {},
        CHOOSE_SWAP_DAY: {
            fromSeriesEventId: null,
            toSeriesEventId: null,
            swapDayData: null,
        },
        SWAP_DAY_SUMMARY: {},
        CHOOSE_TRACK: {
            track: null,
        },
        CHOOSE_TRACK_COURSES: {
            track: target?.track ?? null,
            courses: [],
            trackCoursesSelection: null,
        },
        BOOKING_TYPE: {
            bookingType: HUG_FULL_BOOKING,
            selectedSeriesEvents: null,
            cancelReasonId: null
        },
        PROMO_CODE: getPromoCodeInitialValues({target, initProps}),
        SEND_ALL_DEBTS_LINK: getAllDebtsLinkInitialValues({target, initProps}),
        TRACK_DETAILS: getTrackDetailsInitialValues(target),
        TRACK_PAYMENT_OPTIONS: getTrackPaymentInitialValues(target),
        TRACK_ADVANCED: getTrackAdvancedInitialValues(target),
        COURSE_LIMITATIONS: getCourseLimitationsInitialValues(target),
        REQUIRED_COURSE_FROM_TRACK: {
            series_event_ids: (target?.series_track_series_events ?? []).map(row => row.series_event_id)
        },
        TRACK_TIME_CONFIG: getMultiDayConfigInitialValues(eventDateTime, selectedDay, initProps),
        TRACK_EDIT_TIME_CONFIG: getEditMultiDaysInitialValues(eventDateTime, target),
        TRACK_SETTINGS: getSettingsInitialValues(target),
        CHOOSE_TRACK_PAYMENT_OPTIONS: {
            cart: null,
        },
        APPOINTMENT_WAITLIST: getAppointmentWaitlistAddInitialValues(initProps),
    }
}

export const onNextStep = ({
    EVENT_TYPE: ({dispatch}) => updateSelectionTree(dispatch),
    APPOINTMENT_OR_AVAILABILITY_STEP: ({dispatch}) => updateSelectionTree(dispatch),
    BASIC_INFO: () => console.log('onNext BASIC_INFO'),
    BASIC_INFO_APPOINTMENT: ({dispatch, onSave, values}) => checkSlotStillOpen({dispatch, onSave, values}),
    REPEAT_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    AVAILABILITY_CONFIG: () => console.log('onNext AVAILABILITY_CONFIG'),
    MULTI_DAY_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    SETTINGS: () => console.log('onNext SETTINGS'),
    USER_AND_MEMBERSHIP_SELECTION: ({dispatch}) => updateSelectionTree(dispatch),
    PAYMENT_METHOD_SELECTION: () => console.log('onNext PAYMENT_METHOD_SELECTION'),
    SUCCESS_PAGE: null,
    EDIT_MULTI_DAY_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    MEMBER_DETAILS: ({dispatch}) => memberDetailsOnNext(dispatch),
    SPACE_CONFIGURATION: () => null,
    CUSTOM_FIELD_TYPE_SELECTION: () => null,
    CUSTOM_FIELD_SETTINGS: () => null,
    SERIES_PAYMENT_OPTIONS: () => null,
    TRACK_DETAILS: () => null,
    TRACK_PAYMENT_OPTIONS: () => null,
    TRACK_ADVANCED: () => null,
    TRACK_TIME_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    TRACK_EDIT_TIME_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    TRACK_SETTINGS: () => null,
    CHOOSE_HUG_PAYMENT_TYPE: () => console.log('onNext CHOOSE_HUG_PAYMENT_TYPE'),
    PERSONAL_DETAILS: ({dispatch, onSave}) => checkHugBookingRestrictionsOnBookToHugDetailsStep(dispatch, onSave),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: ({dispatch}) => checkHugBookingRestrictions(dispatch, () => convertLeadOnNextStep(dispatch)),
    CHOOSE_HUG: ({dispatch, onSave}) => checkHugBookingRestrictions(dispatch, () => updateCurrentStep(dispatch, onSave)),
    SWAP_TYPE: ({dispatch}) => updateSelectionTree(dispatch),
    GROUP_DETAILS: ({dispatch, onSave}) => checkHugBookingRestrictionsOnBookToHugDetailsStep(dispatch, onSave),
    BOOK_TO_HUG_CREATE_LEAD: ({dispatch, onSave}) => checkHugBookingRestrictionsOnBookToHugDetailsStep(dispatch, onSave),
    CHOOSE_TRACK: ({dispatch, onSave}) => checkTrackSelection(dispatch, onSave),
    CHOOSE_TRACK_COURSES: ({dispatch, onSave}) => checkTrackCoursesSelection(dispatch, onSave),
    FLOW_FORM_CHOICE: ({dispatch}) => updateSelectionTree(dispatch),
})

export const onBack = ({
    BASIC_INFO_APPOINTMENT: ({dispatch}) => dispatch(updateTempSelection(null)),
    USER_AND_MEMBERSHIP_SELECTION: ({dispatch}) => dispatch(updateTempSelection(null)),
    REPEAT_CONFIG: ({dispatch}) => dispatch(updateTempSelection(null)),
    CHOOSE_TRACK: ({dispatch}) => dispatch(updateTempSelection(null)),
    CHOOSE_TRACK_COURSES: ({dispatch}) => dispatch(updateTempSelection(null)),
    BOOKING_TYPE: ({ formik }) => {
        formik?.setValues({
            ...formik.values,
            bookingType: HUG_FULL_BOOKING,
            selectedSeriesEvents: null,
            cancelReasonId: null,
            cart: null,
            payment_info: null,
            uuidPayment: null,
            res: null,
        });
    },
})

// returns a confirmation config when the step has unsaved changes, or null when it can be closed right away
export const onCloseStep = ({values, initialValues}) => {
    const flowName = store.getState().stepper?.name
    return {
        NOTE: () => {
            const filesChanged = (values?.fileInfo?.files ?? []).some((file) => !file.id || file.shouldRemove)
            return flowName === flowOptions.USER_NOTE && (normalizeText(values?.text) !== normalizeText(initialValues?.text) || filesChanged) ? getDiscardChangesConfirm() : null
        },
    }
}

const getDiscardChangesConfirm = () => ({
    header: t('discard-changes-header'),
    subheader: t('discard-changes-subheader'),
    confirmText: t('back-to-editing'),
    cancelText: t('exit-without-saving'),
})

const renderEventTypeSelectionStep = (props) => {
    return <EventTypeStep initSelection={props?.initSelection || null}/>
}

const renderAppointmentOrAvailabilityStep = (props) => {
    return <OneOnOneType {...props}/>
}

const renderBasicInfoStep = (props) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    let additional = {}

    additional.showMaxUsersTooltip = true;
    additional.showSpaces = (props?.hasPermission('spaces') && !props?.hasPermission('spacesLock'));
    additional.showCoach = true;
    additional.showSeasons = (flowName === flowOptions.HUGIM_FLOW || flowName === flowOptions.HUGIM_FROM_TRACK_FLOW) && props?.hasPermission('seasons') && editType !== SINGLE_SESSION_EDIT_TYPE; //show on create hug or edit series
    additional.allowMultiSpaces = props?.hasPermission('multiSpaces')
    additional.allowScheduleNote = props?.hasPermission('scheduleNoteCreate')
    if(flowName === flowOptions.WORKSHOP_FLOW && editType) {
        additional.disableService = true
        additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    }
    if(flowName === flowOptions.GROUP_CLASS_FLOW && editType) {
        additional.serviceChangeAlert = true
    }
    if(flowName === flowOptions.WORKSHOP_FLOW || flowName === flowOptions.HUGIM_FLOW || flowName === flowOptions.HUGIM_FROM_TRACK_FLOW) {
        additional.showMaxUsersTooltip = false
    }
    if(editType && flowName === flowOptions.HUGIM_FLOW) {
        additional.disableLocation = true
    }
    if(flowName === flowOptions.BLOCKED_TIME) {
        additional.allowMultiSpaces = false
    }
    return <BasicInformation {...additional} {...props}/>
}

const renderRepeatConfigStep = (props) => {
    const flowName = store.getState().stepper?.name
    return <RepeatConfiguration allowSeries={true} {...props}/>
}

//todo - can remove this function and this step all together
export const renderAvailabilityConfigStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {
        disableDate: editType === null
    }
    return <AvailabilitySlotSelection {...additional} {...props}/>
}

const renderSettingsStep = (props) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType

    let additional = {}
    switch (flowName) {
        case flowOptions.GROUP_CLASS_FLOW:
            additional.showTransparentSettings = true;
            additional.showSpots = true;
            additional.showCancellationSettings = true;
            additional.showRegistrationRestrictionsSettings = true;
            additional.showRegistrationBlockSettings = true;
            additional.showMinimumParticipantsSettings = true;
            additional.showGenderRestrictionSettings = true;
            additional.showAgeRestrictionSettings = true;
            additional.showGroupRegisterSettings = false;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = (props?.values.repeatConfig?.repeat && (props?.values.repeatConfig.type === 'forever') && props?.values.repeatConfig.days.length === 1) || (editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && props?.target?.series_fk);
            additional.showBookForTrialSettings = props?.values.repeatConfig?.repeat || (editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && props?.target?.series_fk)
            break;
        case flowOptions.WORKSHOP_FLOW:
            additional.showTransparentSettings = false;
            additional.showCancellationSettings = false;
            additional.showRegistrationRestrictionsSettings = false;
            additional.showRegistrationBlockSettings = false;
            additional.showMinimumParticipantsSettings = false;
            additional.showGroupRegisterSettings = (props?.hasPermission('allowRegisterGroupMember') && editType !== SINGLE_SESSION_EDIT_TYPE) ?? false;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = editType !== SINGLE_SESSION_EDIT_TYPE;
            break;
        case flowOptions.HUGIM_FLOW:
            additional.showTransparentSettings = false;
            additional.showCancellationSettings = false;
            additional.showRegistrationRestrictionsSettings = false;
            additional.showRegistrationBlockSettings = false;
            additional.showMinimumParticipantsSettings = false;
            additional.showAgeRestrictionSettings = true;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = editType !== SINGLE_SESSION_EDIT_TYPE;
            additional.showGroupRegisterSettings = (props?.hasPermission('allowRegisterGroupMember') && editType !== SINGLE_SESSION_EDIT_TYPE) ?? false;
            additional.defaultOpenedSection = 'seriesNameSetting';
            additional.showMidBookingSettings = editType !== SINGLE_SESSION_EDIT_TYPE && !props?.values?.isOneDay;
            break;
    }
    return <SessionSettings displayProps={additional} {...props}/>
}

const renderMultiDayConfigStep = (props) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showCoachSelect = flowName !== flowOptions.SPACE_AVAILABILITY
    additional.showSpacesSelect = flowName === flowOptions.SPACE_AVAILABILITY
    additional.servicesTypeOverride = flowName === flowOptions.SPACE_AVAILABILITY ? APPOINTMENT : null
    additional.showLocationSelect = flowName === flowOptions.AVAILABILITY
    additional.showUnlimitedOption = flowName === flowOptions.HUGIM_FLOW && props?.hasPermission('recurringPaymentActions')
    additional.showShortenName = flowName === flowOptions.HUGIM_FLOW
    additional.updateDatesBySeason = flowName === flowOptions.HUGIM_FLOW && props?.hasPermission('seasons') && !editType; //update dates only on create hug
    additional.showDayDescription = flowName === flowOptions.HUGIM_FLOW
    return <MultiDayConfiguration {...additional} {...props}/>
}

const renderBasicInfoAppointmentStep = (props) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const fromAvailability = (flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY)
    let additional = {
        showMaxUsersTooltip: true,
        showSpaces: props?.hasPermission('spaces') && !props?.hasPermission('spacesLock'),
        showCoach: true,
        allowMultiSpaces: props?.hasPermission('multiSpaces') && !fromAvailability,
        fromAvailability: fromAvailability,
        disableDate: editType === null,
        allowSeries: false,
        singleEventRadioFirst: true,
        hideCustomFields: true,
        disableService: !!(fromAvailability && editType)
    }

    //i moved this from old flow, this is messy but i didn't want to risk changing anything here
    if(flowName === flowOptions.APPOINTMENT_BASIC && editType) {
        const box = store.getState().box?.box
        additional.disableLocation = box?.hasInvoiceSeparation || props?.target?.availability_id
    }
    if(fromAvailability && props.values.locations_box_fk) {
        additional.disableLocation = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY && editType) {
        additional.disableLocation = true
        additional.disableCoach = true
        additional.showCoach = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY && !editType) {
        additional.showCoach = false
        additional.disableSpace = true
        additional.disableLocation = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY && editType) {
        additional.disableLocation = true
        additional.disableSpace = true
        additional.showSpaces = true
        additional.showCoach = false;
    }
    if(props?.initProps?.waitlist) {
        const relevantProp = props?.initProps.waitlist?.props?.[0]
        additional.waitlistOriginalInfo = relevantProp ? {coach_fk: relevantProp.coach?.user_fk, box_category_fk: relevantProp.box_categories_id} : null
    }

    return <BasicInfoAppointment {...additional} {...props}/>
}

const renderTrackTimeConfigStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showShortenName = true
    additional.updateDatesBySeason = props?.hasPermission('seasons') && !editType; //update dates only on create hug
    additional.showDayDescription = true
    return <MultiDayConfiguration {...additional} {...props}/>
}

const renderTrackEditTimeConfigStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.hideBlockRegistrationTime = true
    additional.showOnlyTimeSelectors = editType === SINGLE_SESSION_EDIT_TYPE
    additional.singleDay = editType === SINGLE_SESSION_EDIT_TYPE
    additional.allowDaySwitch = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    additional.allowEditDateRange = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    additional.showDaysEditInfoText = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    additional.showDayDescription = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    return <EditMultiDayConfig {...additional} {...props}/>
}

const renderTrackSettingsStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showOnlineSessionSettings = true
    additional.showSeriesNameSettings = true
    additional.defaultOpenedSection = 'seriesNameSetting'
    additional.showBookForTrialSettings = (editType !== SINGLE_SESSION_EDIT_TYPE) && !props?.hasPermission('addNewLeadLock')
    additional.hideSiteTrialOption = true
    return <SessionSettings displayProps={additional} {...props}/>
}

const renderCourseLimitationsStep = (props) => {
    return <CourseLimitations {...props}/>
}

const renderRequiredCourseFromTrackStep = (props) => {
    return <RequiredCourseFromTrack {...props}/>
}

export const renderEditMultiDayConfig = (props) => {
    let additional = {}
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType
    let hasSchedules;
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            additional.disableDate = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.disableDays = editType === SINGLE_SESSION_EDIT_TYPE
            additional.allowDaySwitch  = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.showLength = true
            additional.hideBlockRegistrationTime = true
            break;
        case flowOptions.HUGIM_FLOW:
            const isOneDayHug = props.target?.series?.start_date === props.target?.series?.end_date
            additional.hideBlockRegistrationTime = true
            additional.showOnlyTimeSelectors = editType === SINGLE_SESSION_EDIT_TYPE
            additional.singleDay = editType === SINGLE_SESSION_EDIT_TYPE
            additional.allowDaySwitch = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && !isOneDayHug
            additional.allowEditDateRange = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.showDaysEditInfoText = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.isOneDayHug = isOneDayHug
            additional.showDayDescription = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && !isOneDayHug
            break;
        case flowOptions.AVAILABILITY:
            hasSchedules = props.target?.hasSchedules;
            additional.disableDate = true
            additional.disableDays = false
            additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE ? hasSchedules : true // if edit all then enable only if there are no connected schedules. else (aka single edit), disable always
            additional.disableCoach = hasSchedules
            additional.allowDaySwitch = false
            additional.allowTimeExpandOnly = hasSchedules
            additional.singleDay = true
            additional.showServices = true
            additional.showLocationSelect = true
            additional.showCoachSelect = true
            additional.showSpaceSelect = false
            break;
        case flowOptions.SPACE_AVAILABILITY:
            hasSchedules = props.target?.hasSchedules;
            additional.disableDate = true
            additional.disableDays = false
            additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE ? hasSchedules : true // if edit all then enable only if there are no connected schedules. else (aka single edit), disable always
            additional.disableSpaces = hasSchedules
            additional.allowDaySwitch = false
            additional.allowTimeExpandOnly = hasSchedules
            additional.singleDay = true
            additional.showServices = true
            additional.showLocationSelect = true
            additional.showCoachSelect = false
            additional.showSpaceSelect = true
            additional.servicesTypeOverride = APPOINTMENT
            additional.disableSpace = hasSchedules
            break;
    }
    return <EditMultiDayConfig {...additional} {...props}/>
}

const renderUserAndMembershipSelection = (props) => {
    let additional = {}
    const isRepeat = props?.values?.repeatConfig?.repeat === true
    additional.oneTimeMembership = getOneTimeMembership(props.values)
    additional.showOneTimePurchase = !!(!isRepeat && additional?.oneTimeMembership)
    additional.allowMultiOneTimeMembership = !!additional.oneTimeMembership && isMultiPayForSlotRepeat(props?.values?.repeatConfig, props?.values?.date)
    additional.allowScheduleNote = props?.hasPermission('scheduleNoteCreate')

    return <UserAndMembershipSelection {...additional} {...props}/>
}

const renderSpaceConfigStep = (props) => {
    return <SpaceConfiguration {...props}/>
}

const renderPaymentMethodSelection = (props) => {
    return <PaymentMethod {...props}/>
}

const renderMemberDetails= (props) => {
    return <MemberDetails {...props}/>
}

const renderStaffMemberRoleSelect= (props) => {
    return <StaffMemberRoleSelection {...props}/>
}

const renderBlockedTime= (props) => {
    return <BlockedTime {...props}/>
}

const renderMessageTypeSelect= (props) => {
    return <MessageType {...(props || {})}/>
}

const renderMessageDetails= (props) => {
    return <MessageDetails {...(props || {})}/>
}

const renderAppointmentWaitlistAdd = (props) => {
    return <AppointmentWaitlistAdd {...(props || {})}/>
}

const renderEmailAfterPurchase = (props) => {
    return <EmailAfterPurchase {...props}/>
}

const renderDocumentsAutoSendSettings = (props) => {
    return <DocumentsAutoSendSettings {...props} />
}

const renderPenaltySettingsConfigStep = (props) => {
    return <PenaltySettings {...props}/>
}

const renderPenaltySummaryStep = (props) => {
    return <PenaltySummary {...props}/>
}

const renderPenaltyExtraPropertiesConfigStep = (props) => {
    return <PenaltyExtraProperties {...props}/>
}

const renderTaskDetailsStep = (props) => {
    return <TaskDetails {...props}/>
}

const renderTaskTypeStep = (props) => {
    return <CreateTaskType {...props}/>
}

const renderCustomFieldTypeSelection = (props) => {
    return <CustomFieldSelection {...props} />;
}

const renderCustomFieldSettings = (props) => {
    const target = props.target;
    const addons = {isTypeDisabled: !!target, currentFlows: target?.custom_field_flow}
    return <CustomFieldSettings {...props} {...addons}/>;
}

const renderSuccessStep = (props) => {
    const addonProps = getSuccessProps({...props})
    return <SuccessStep {...addonProps} {...props}/>
}

const renderSeriesPaymentOptionsStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showEditMessage = editType !== null
    additional.isEdit = editType !== null
    additional.showTrialOption = props?.hasPermission('bookForTrialHugim') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.hasHideFullHugInSiteProp = !!props?.target?.series?.hide_full_hug_in_site_prop
    additional.showOnetimeOption = editType !== SINGLE_SESSION_EDIT_TYPE
    return <SeriesPaymentOptions {...additional} {...props}/>
}

export const shouldSkipHugPaymentStep = (values, target, flowName) => {
    if (flowName !== flowOptions.SWAP_HUG_REGISTRATION && flowName !== flowOptions.HUG_NEW_REGISTRATION) return false;
    const targetOverride = values;
    if (!targetOverride?.eventData?.series) return false;
    const selectedNumOfDays = targetOverride.bookingType === HUG_FULL_BOOKING ? null : parseInt(targetOverride.bookingType.split('_').pop(), 10);
    const paymentOptions = selectedNumOfDays
        ? targetOverride.eventData.series.partialBookingOptions.filter(option => ([MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(option.type) && (option.numOfDays === selectedNumOfDays)))
        : targetOverride.eventData.series.membership_types_all.filter(mt => [MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(mt.type) && !mt.membership_types_partial_prop);
    return paymentOptions.length === 1;
}

const renderChoosePaymentOptionsStep = (props) => {
    const flowName = store.getState().stepper.name;
    let additional = {}
    const targetOverride = [flowOptions.SWAP_HUG_REGISTRATION, flowOptions.HUG_NEW_REGISTRATION].includes(flowName) ? props.values : props.target;
    const selectedNumOfDays = targetOverride.bookingType === HUG_FULL_BOOKING ? null : parseInt(targetOverride.bookingType.split('_').pop(), 10);
    additional.paymentOptions = selectedNumOfDays ?
        targetOverride.eventData.series.partialBookingOptions.filter(option => ([MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(option.type) && (option.numOfDays === selectedNumOfDays)))
        :
        targetOverride.eventData.series.membership_types_all.filter(mt => [MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(mt.type) && !mt.membership_types_partial_prop)
    additional.startDate = targetOverride.eventData.date;
    additional.skipStep = shouldSkipHugPaymentStep(props.values, props.target, flowName);
    return <HugPaymentsOptions {...additional} {...props}/>
}

const renderChooseTrackPaymentOptionsStep = (props) => {
    let additional = {}
    additional.paymentOptions = props.values.track.membership_types_all
    const trackStartDate = moment(props.values.track.start_date, dbDateFormat)
    additional.startDate = trackStartDate && !trackStartDate.isBefore(moment(), 'day')
        ? trackStartDate.format(dbDateFormat)
        : moment().format(dbDateFormat);
    return <HugPaymentsOptions {...additional} {...props}/>
}

export const getCartOverrideByFlow = (flowName, values) => {
    let cartOverride = null
    switch(flowName) {
        case flowOptions.APPOINTMENT_BASIC:
        case flowOptions.APPOINTMENT_WITH_AVAILABILITY:
        case flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY:
            const oneTimeMembership = getOneTimeMembership(values)
            if(oneTimeMembership) {
                cartOverride = [{...oneTimeMembership, start: values?.date, end: values?.date}]
            }
            break;
    }
    return cartOverride
}

const renderPayment = (props) => {
    const flowName = store.getState().stepper.name
    const flowProps = store.getState().stepper.props
    const membership = store.getState().stepper.selectionsTree[optionalSteps.CHOOSE_HUG_PAYMENT_TYPE]
    const trialMT = props.target?.eventData?.series?.membership_types_all?.find(mt => MembershipTypes.TRIAL_CLASS === mt.type) ?? null;
    const onetimeMT = props.target?.eventData?.series?.membership_types_all?.find(mt => MembershipTypes.ONETIME === mt.type) ?? null;
    let additional = {}
    if((flowName === flowOptions.BOOK_TO_HUG_FLOW || flowName === flowOptions.BOOK_TO_HUG_CONVERT_LEAD || flowName === flowOptions.SWAP_HUG_REGISTRATION) && membership) {
        additional.cartOverride = [membership]
    } else if ((flowName === flowOptions.BOOK_TO_HUG_TRIAL || flowName === flowOptions.BOOK_TO_GROUP_CLASS_TRIAL || flowName === flowOptions.BOOK_TO_HUG_CREATE_LEAD) && trialMT) {
        additional.cartOverride = [{...trialMT, start: props.target.eventData.date}]
    } else if (flowName === flowOptions.CLOSE_MU_DEBT) {
        additional.membership_user_id = flowProps.initProps.membership_user.id
        additional.locationOverride = flowProps.initProps.membership_user.membership_types.location_box_fk
    } else if(flowName === flowOptions.BOOK_TO_HUG_ONETIME && onetimeMT) {
        additional.cartOverride = [{...onetimeMT, start: props.target.eventData.date}]
    }
    if (flowName === flowOptions.PAYMENT_FLOW || flowName === flowOptions.PAY_FOR_SLOT_GROUP_CLASS) {
        const stepperProps = store.getState().stepper.props
        if (stepperProps.cartOverride) {
            additional.cartOverride = stepperProps.cartOverride
        }
    }
    return <Payment {...additional} {...props}/>
}

const getOneTimeMembership = (values) => {
    const flowName = store.getState().stepper.name
    const selectionsTree = store.getState().stepper.selectionsTree
    const services = store.getState().schedule.eventTypes.data
    let oneTimeMembership = null;
    if(services && selectionsTree && selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]) { //TODO with eden
        oneTimeMembership = services[selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]].find(category => category.id === values?.box_category_fk)
        oneTimeMembership = oneTimeMembership?.membership_types.find(membership => membership.location_box_fk === values?.locations_box_fk)
    } else if(services && flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY) {
        oneTimeMembership = services['appointment'].find(category => category.id === values?.box_category_fk)
        oneTimeMembership = oneTimeMembership?.membership_types.find(membership => membership.location_box_fk === values?.locations_box_fk)
    }
    return oneTimeMembership
}

const renderPersonalDetails = (props) => {
    const flowName = store.getState().stepper.name
    let additional = {}
    switch (flowName) {
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            additional.showCreateLeadFields = true

    }
    return <PersonalDetails displayProps={additional} {...props}/>

}

const renderSendLink = (props) => {
    const flowName = store.getState().stepper.name
    let additional = {}
    additional.hideNewUsersMemberships = true
    switch (flowName) {
        case flowOptions.SEND_LINK_TO_MEMBERSHIP_FLOW:
            additional.showPushOption = props.target.user?.type === 'user' || props.target.showPushOption
            additional.showOnlyHugim = props.target.showOnlyHugim
            additional.showOnlyItems = props.target.fromLeadProfile && !additional.showOnlyHugim
            additional.hideWhatsappOption = props.target?.hideWhatsappOption
            additional.tags = [
                { id: 'first_name', label: t('firstName') },
                { id: 'last_name', label: t('lastName') },
                { id: 'membership_link', label: t('link-to-membership'), isError: true },
            ];
            additional.hideNewUsersMemberships = !props.target.hideNewUsersMemberships
            additional.metaWhatsappTemplateEvent = 'membershipLink'
            break;
        case flowOptions.CONVERT_LINK_FLOW:
            additional.hideWhatsappOption = props.target?.hideWhatsappOption
            additional.showOnlyPlanAndSessionPacks = true
            additional.membershipSelectionTooltip = true
            additional.tags = [
                { id: 'first_name', label: t('firstName') },
                { id: 'last_name', label: t('lastName') },
                { id: 'convert_link', label: t('link-to-convert'), isError: true },
            ];
            additional.hideNewUsersMemberships = false
            additional.metaWhatsappTemplateEvent = 'convertLink'
            break;

    }
    return <SendLink displayProps={additional} {...props} />

}

const renderRequiredFieldsSettings = (props) => {
    let additional = {}
    const hasGroup = props?.hasPermission('allowRegisterGroupMember') ?? false
    additional.infoTooltip = hasGroup && props.initProps.type !== USER_SITE_FIELDS ? {member: t('groupMemberFieldsTooltip')} : null
    return <RequiredFieldsSettings {...additional} {...props}/>
}

const renderAccountCardsSettings = (props) => {
    return <AccountCardsSettings {...props}/>
}

const renderOrganizationPriceList = (props) => {
    return <OrganizationPriceList {...props}/>
}

const renderChooseGroupConnectionUser = (props) => {
    return <ChooseGroupConnectionUser {...props}/>
}

const renderGroupConnectionAddUser = (props) => {
    return <GroupConnectionAddUser {...props}/>
}

const renderSiteTrialSettings = (props) => {
    return <SiteTrialSettings {...props}/>
}

const renderGatesApplySettings = (props) => {
    return <GatesApplySettings {...props}/>
}

const renderGatesActivityHours = (props) => {
    return <GatesActivityHours {...props}/>
}

const renderSiteLeadFormSettings = (props) => {
    return <SiteLeadFormSettings {...props} />
}

const renderAdvancedSeriesSettings = (props) => {
    const editType = store.getState().stepper?.editType
    const box = store.getState().box.box;
    const isIL = box?.locations_box[0]?.country_code === 'IL';
    let additional = {}
    additional.isEdit = editType !== null
    additional.showTrialOption = props?.hasPermission('bookForTrialHugim') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showAddonsOption = isIL && props?.hasPermission('hugimAddons') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showUpsellOption = isIL && props?.hasPermission('upsell') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showHugFormOption = editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showOnetimeOption = editType !== SINGLE_SESSION_EDIT_TYPE
    additional.numOfWeekdaysInSeries = (props?.values.days ?? props?.values.multiDayConfig.days ?? []).length
    return <AdvancedSeriesSettings {...additional} {...props}/>
}

const renderExport = (props) => {
    return <Export {...props} />
}

const renderSendInvoicesReport = (props) => {
    return <SendInvoicesReport {...props} />
}

const renderSendDoctorJournalReport = (props) => {
    return <SendDoctorJournalReport {...props} />
}

const renderNoteTemplate = (props) => {
    return <NoteTemplate {...props} />
}

const renderNote = (props) => {
    const editType = store.getState().stepper?.editType
    const flowName = store.getState().stepper.name
    const box = store.getState().box.box;
    const lang = store.getState().userSettings.lang
    const innerInitProps = store.getState().stepper?.props?.initProps
    const boxLocale = lang?.language === 'Hebrew' ? 'he' : 'en'
    const timeFormat = box ? box.locations_box[0].time_format : null
    const isSeriesEdit = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    const initProps = innerInitProps ?? props.initProps
    const isBlockTimeNote = flowName === flowOptions.SCHEDULE_NOTE && !initProps?.scheduleTarget?.box_categories

    let additional = {
        targetSchedule: props.target?.relatable ?? null, //for user note schedule, not for schedule note! (confusing, i know)
        hideTemplate: !!editType || (flowName === flowOptions.SCHEDULE_NOTE),
        hideScheduleSelect: initProps?.schedule_id || (flowName === flowOptions.SCHEDULE_NOTE),
        scheduleNoteLabel: (editType && initProps?.scheduleTarget && (flowName === flowOptions.SCHEDULE_NOTE)) ? `(${t(`${isSeriesEdit ? 'series' : 'schedule'}-edit-note-date`, {date: `${moment(`${initProps.scheduleTarget.date} ${initProps.scheduleTarget.time}`, `${dbDateFormat} ${dbTimeFormat}`).locale(boxLocale).format(`dddd, MMMM D, YYYY ${timeFormat}`)}`})})` : null,
        placeholder: flowName === flowOptions.SCHEDULE_NOTE ? t('add-session-note-here-placeholder') : null,
        showPin: flowName === flowOptions.USER_NOTE && hasPermissions(['pinNoteAction']),
        showFileUpload: flowName === flowOptions.USER_NOTE,
        showOnCheckinOption: (!!editType || (flowName === flowOptions.SCHEDULE_NOTE)) && !isBlockTimeNote,
        allowTable: flowName === flowOptions.USER_NOTE
    }
    return <Note {...additional} {...props} />
}

const renderGroupDetails = (props) => {
    return <GroupDetails {...props} />
}

const renderFlowForm = (props) => {
    let additional = {}
    additional.showHugimSection = props?.hasPermission('hugim')
    return <FlowForm {...additional} {...props}/>
}

const renderFlowFormChoice = (props) => <FlowFormChoice {...props} />

const renderFlowFormManage = (props) => <FlowFormManage {...props} />

const renderSendDebtLink = (props) => {
    let additional = {}
    const fromReport = props.target?.type === 'reports'
    additional.showPushOption = props.target.user?.type === 'user' || fromReport
    additional.hideWhatsappOption = fromReport
    additional.hideMembershipSelect = true
    additional.showExpirationDatePicker = true
    const hasScheduleConnection = !!props.target?.user?.schedule_user_id
    additional.tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'membership_type', label: t('membershipType') },
        { id: 'debt_amount', label: t("debt-amount") },
    ];
    if(hasScheduleConnection) {
        additional.tags.push({ id: 'coach', label: t('coachName') })
    }
    additional.tags.push({ id: 'debt_link', label: t('link-to-debt'), isError: true })
    additional.metaWhatsappTemplateEvent = 'debtLink'
    return <SendLink displayProps={additional} {...props} />
}

const renderSendAllDebtsLink = (props) => {
    let additional = {}
    const fromReport = props.target?.type === 'reports'
    additional.showPushOption = props.target.user?.type === 'user' || fromReport
    additional.hideWhatsappOption = fromReport
    additional.hideMembershipSelect = true
    additional.showExpirationDatePicker = true
    additional.emptyUsersError = t('no-selected-users-all-debt-error')
    additional.tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'mu_amount', label: t("mu-amount")},
        { id: 'all_debts_amount', label: t("all-debts-amount")},
        { id: 'all_debts_link', label: t('link-to-all-debts'), isError: true},
    ];
    return <SendLink displayProps={additional} {...props} />
}

const renderSendConfirmationLink = (props) => {
    let additional = {}
    additional.showPushOption = props.target.user?.type === 'user'
    additional.hideMembershipSelect = true
    additional.tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'confirmation_link', label: t('link-to-confirmation'), isError: true },
        { id: 'date', label: t('date') },
        { id: 'day', label: t('day'), translate: true },
        { id: 'time', label: t('startTime') },
        { id: 'end_time_schedule', label: t('end-time') },
        { id: 'session_name', label: t('sessionName') },
        { id: 'coach', label: t('coach') },
        ...(props.hasPermission('spaces') ? [{ id: 'space', label: t('space') }] : []),
        ...(store.getState().box.box?.locations_box?.length > 1 ? [{ id: 'location', label: t('location') }] : [])
    ];
    additional.metaWhatsappTemplateEvent = 'appoConfirmLink'
    return <SendLink displayProps={additional} {...props} />
}

const renderBuildUniformReport = (props) => {
    return <BuildUniformReport {...props}/>
}

const renderUserChargeSetting = (props) => {
    let additional = {}
    additional.paymentProvider = props.initProps?.paymentProvider
    return <UserChargeSetting {...additional} {...props}/>
}

const renderUserNoteExport = (props) => {
    let additional = {}
    let tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
    ];
    if(props.target.relatable_id) {
        tags.push({ id: 'date', label: t('date') })
        tags.push({ id: 'time', label: t('startTime')})
    } else {
        tags.push({ id: 'note_date', label: t('noteDate') })
        tags.push({ id: 'note_time', label: t('noteTime')})
    }
    additional.tags = tags
    return <UserNoteExport {...additional} {...props} />
}

const renderPromoCode = (props) => {
    return <PromoCode {...props}/>
}

const renderChooseHug = (props) => {
    return <ChooseHug {...props}/>
}

const renderSwapType = (props) => {
    return <SwapType {...props}/>
}

const renderChooseSwapDay = (props) => {
    return <ChooseSwapDay {...props}/>
}

const renderSwapDaySummary = (props) => {
    return <SwapDaySummary {...props}/>
}

const renderChooseTrack = (props) => {
    return <ChooseTrack {...props}/>
}

const renderChooseTrackCourses = (props) => {
    return <ChooseTrackCourses {...props}/>
}

const renderBookingType = (props) => {
    const flowName = store.getState().stepper.name
    let additional = {}
    additional.showCancelReason = flowName === flowOptions.SWAP_HUG_REGISTRATION
    return <BookingType {...additional} {...props} />
}

const renderTrackDetailsStep = (props) => {
    return <TrackDetails {...props}/>
}

const renderTrackPaymentStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showEditMessage = editType !== null
    additional.isEdit = editType !== null
    additional.TrackCreationFlow = true
    return <SeriesPaymentOptions {...additional} {...props}/>
}

const renderTrackAdvancedStep = (props) => {
    const editType = store.getState().stepper?.editType
    const box = store.getState().box.box;
    const isIL = box?.locations_box[0]?.country_code === 'IL';
    let additional = {}
    additional.isEdit = editType !== null
    additional.showAddonsOption = isIL && props?.hasPermission('hugimAddons')
    additional.showGroupRegisterSettings = props?.hasPermission('allowRegisterGroupMember')
    additional.showMidBookingSettings = true
    additional.TrackCreationFlow = true
    additional.showHugFormOption = true
    return <AdvancedSeriesSettings {...additional} {...props} />
}

const getMultiDayConfigInitialValues = (eventDateTime, selectedDay, initProps) => {
    const flowName = store.getState().stepper.name
    const day = moment(eventDateTime?.date).day()
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return {
                start_date: eventDateTime?.date ?? moment().format(dbDateFormat),
                end_date: eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).add(1, 'month').format(dbDateFormat) : moment().add(1, 'month').format(dbDateFormat),
                multiDayConfig: {
                    days: selectedDay ? [{day: selectedDay, start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}] : [{day: moment().day(), start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}],
                    seriesName: ''
                },
            }
        case flowOptions.HUGIM_FLOW:
        case flowOptions.HUGIM_FROM_TRACK_FLOW:
            return {
                isUnlimited: false,
                isOneDay: false,
                start_date: eventDateTime?.date ?? moment().format(dbDateFormat),
                end_date: eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).add(1, 'month').format(dbDateFormat) : moment().add(1, 'month').format(dbDateFormat),
                multiDayConfig: {
                    days: selectedDay ? [{day: selectedDay, start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}] : [{day: moment().day(), start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}],
                    seriesName: ''
                },
            }
        case flowOptions.AVAILABILITY:
            return {
                date: eventDateTime?.date ?? moment().format(dbDateFormat),
                location_fk: null,
                coach_ub_id: hasLimitedCoachViewSchedule() ? store.getState().user?.user?.id : (initProps?.coach_ub_id ?? null),
                repeat: true,
                slot_length: 15,
                break_length: 0,
                block_registration_time: 0,
                multiDayConfig: [{day: day, setting: [{start_time: '09:00:00', end_time: '17:00:00', limitations: []}]}]
            }
        case flowOptions.SPACE_AVAILABILITY:
            return {
                date: eventDateTime?.date ?? moment().format(dbDateFormat),
                location_fk: null,
                spaces_id: initProps?.spaces_id ?? null,
                repeat: true,
                slot_length: 15,
                break_length: 0,
                block_registration_time: 0,
                multiDayConfig: [{day: day, setting: [{start_time: '09:00:00', end_time: '17:00:00', limitations: []}]}]
            }
        default:
            return {}
    }
}

const getMultiDayConfigValidationSchema = () => {
    const flowName = store.getState().stepper?.name
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
        case flowOptions.HUGIM_FROM_TRACK_FLOW:
            return getBasicWorkshopValidationSchema().shape({
                end_date: yup.string().required(t('thisFieldIsMandatory')).when(['start_date'], (start_date, schema) => {
                    const start = moment(start_date, dbDateFormat)
                    return schema.test({
                        test: end => moment(end, dbDateFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('date-format', 'invalid date', function(value){
                    return moment(value, dbDateFormat).format(dbDateFormat) === value
                }),
            })
        case flowOptions.HUGIM_FLOW:
            return getBasicWorkshopValidationSchema().shape({
                isUnlimited: yup.boolean(),
                isOneDay: yup.boolean(),
                end_date: yup.string().when("isUnlimited", {
                    is: true,
                    then: yup.string().nullable(true).test('is-null', 'end_date must be null', value => value === null), //must be null when isUnlimited=true
                    otherwise: yup.string().required(t('thisFieldIsMandatory')).when(['start_date', 'isOneDay'], (start_date, isOneDay, schema) => {
                        const start = moment(start_date, dbDateFormat)
                        return schema.test({
                            test: end => end && (isOneDay ? moment(end, dbDateFormat).isSame(start) : moment(end, dbDateFormat).isAfter(start)),
                            message: t('shiftTimeError')
                        })
                    }).test('date-format', 'invalid date', function(value){
                        return value && (moment(value, dbDateFormat).format(dbDateFormat) === value)
                    }),
                })
            })
        case flowOptions.AVAILABILITY:
            return getAvailabilityBasicValidationSchema().shape({
                location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                coach_ub_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.SPACE_AVAILABILITY:
            return getAvailabilityBasicValidationSchema().shape({
                location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                spaces_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        default:
            return yup.object().shape({})
    }
}

const getBasicInfoInitialValues = (target, initProps) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const scheduleTarget = target
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
        target = target.series
    }
    let values = {
        box_category_fk: target?.box_category_fk ?? null,
        coach_fk: target?.coach_fk ?? target?.coach?.user_fk ?? initProps?.coach_fk ?? null,
        locations_box_fk: target?.locations_box_fk ?? target?.location_fk ?? null,
        spaces_id: target?.spaces_id ?? initProps?.spaces_id ?? null,
        season_id: target?.season_id ?? initProps?.season_id ?? null,
        customFields: customFieldInit(target, editType, flowName === flowOptions.HUGIM_FROM_TRACK_FLOW ? flowOptions.HUGIM_FLOW : null),
        scheduleTarget: scheduleTarget ?? null,
        spaces_relation: getSpacesRelationForEdit(scheduleTarget),
        max_users: target?.max_users ?? null,
        second_coach_fk: target?.second_coach_fk ?? null,
    }
    if (!editType && hasLimitedCoachViewSchedule()) {
        values.coach_fk = store.getState().user?.user?.user_fk;
    }

    return values;
}

const getUserAndMembershipInitialValues = (target, initProps) => {
    const editType = store.getState().stepper.editType
    let bookingProps = {}
    if(editType) {
        bookingProps = {
            bookedUser: target?.schedule_user?.booked?.[0] ?? initProps?.waitlist?.users_box,
        }
    } else if(initProps?.waitlist?.users_box) {
        const userBox = target?.schedule_user?.booked?.[0] ?? initProps?.waitlist?.users_box
        bookingProps = {
            bookedUser: userBox,
            scheduleUser: {
                user_fk: userBox?.user_fk,
                membership_user_fk: null,
                isLead: false,
                paymentObject: null,
                force: false,
                sendInvitation: false,
                isNoMembership: false
            }
        }

    } else {
        bookingProps = {
            scheduleUser: {
                user_fk: null,
                membership_user_fk: null,
                isLead: false,
                paymentObject: null,
                force: false,
                sendInvitation: false,
                isNoMembership: false
            }
        }
    }
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
        target = target.series
    }
    let vals = {
        ...bookingProps,
        live_link: target?.live_link ?? null,
        customFields: customFieldInit(target, editType, flowOptions.APPOINTMENT_BASIC)
    }
    return vals
}

const getSpacesRelationForEdit = (target) => {
    const editType = store.getState().stepper?.editType
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
        return target?.series?.spaces_relation?.length ? target.series.spaces_relation :  null
    } else if(editType === SINGLE_SESSION_EDIT_TYPE) {
        return handleEventSpacesRelation(target);
    } else return null
}

const customFieldInit = (target, editType, flowNameOverride = null, filterByCurrentLocation = false) => {
    let temp = [];
    const flowName = store.getState().stepper?.name;
    const isUserFlowType = userFlowsOnly.includes(flowName);
    const userCustomFields = filterByCurrentLocation ?
                            store.getState().schedule.userCustomFields?.filter(customField => customField.locations_box.some(location => location.id === target?.locations_box_fk)) :
                            store.getState().schedule.userCustomFields;

    const scheduleCustomFields = store.getState().schedule.scheduleCustomFields
    const customFieldByFlowType = isUserFlowType ? userCustomFields : scheduleCustomFields;
    const customFieldByFlowName = customFieldByFlowType?.filter(customField => customField.custom_field_flow.some(flowObj => flowObj.flow.name === (flowNameOverride ?? flowName)))
    const currentFields = target?.custom_field_value?.length ? target?.custom_field_value : target?.series?.custom_field_value;

    const byFlowNameFormatted = customFieldByFlowName?.map(field => ({
        ...field,
        custom_field_id: field.id,
        customFieldType: isUserFlowType ? USER_TYPE_TC : SCHEDULE_TYPE_TC, //not sure why its capitalized, not changing because im afraid to break something.
        props: field.props,
        editType: editType,
        date: target?.date,
        modelId: target?.id,
        value: field?.value,
    }));

    if(isUserFlowType) {
        //TODO (might be changed in the future)
        // in case its user type, otherwise continue to the array merge (happens just for schedule, might be changed later)
        return byFlowNameFormatted;
    }

    const currentFieldsFormatted = currentFields?.map(field => ({
            id: field.custom_field.id,
            custom_field_value_id: field.id,
            custom_field_id: field.custom_field.id,
            custom_field_name: field.custom_field.name,
            custom_field_type: field.custom_field.type,
            props: field.custom_field.props,
            customFieldType: 'Schedule', //TODO get it from somewhere
            editType: editType,
            date: target.date,
            modelId: target.id,
            value: field.value
    }));

    temp = [...currentFieldsFormatted ?? [], ...byFlowNameFormatted ?? []];
    return uniqBy(temp, 'id');
}

const getCustomFieldValueValidationSchema = () => {
    return yup.array(yup.object().shape({
        value: yup.string().nullable()
            .when('props', {
                is: value => value.isRequired,
                then: schema => schema.required(t('thisFieldIsMandatory'))
            })
            .when('custom_field_type', {
                is: value => value === 'phone',
                then: schema => schema.matches(/^(\+?\d{5,15})$/, t('non-numeric-chars')).min(5, t('phoneNumberIsTooShort', {min: 5})),
            }),
    }));
}

const getCustomFieldSettingsInitialValues = (target) => {
    const box = store.getState().box.box;
    const locationOptions =
        target?.locations_box ?
            (Array.isArray(target.locations_box) ?
                target.locations_box.map(location => ({ id: location.id, value: location.id, label: location.location })) :
                []) :
            (Array.isArray(box?.locations_box) ?
                box.locations_box.map(location => ({ id: location.id, value: location.id, label: location.location })) :
                []);
    const selectionsTree = store.getState().stepper.selectionsTree;
    const customFieldType = target?.flow_type ?? selectionsTree[optionalSteps.CUSTOM_FIELD_TYPE_SELECTION] ?? null;

    const data = {
        custom_field_id: target?.id ?? null,
        customFieldName: target?.custom_field_name ?? '',
        locations: locationOptions,
        inputType: target?.custom_field_type ?? customFieldTypes.SELECT,
        props: target?.props ?? {isRequired: true, showInCheckin: false},
        flows: [],
    }
    if(customFieldType) { //in case of user funnel is selected
        return {...data, customFieldType }
    }

    return data;
}

const getBasicInfoAppointmentInitialValues = (target, initProps, eventDateTime, selectedDay, selectedTime) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const fromAvailability = [flowOptions.APPOINTMENT_WITH_AVAILABILITY, flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY].includes(flowName)
    let waitlist = null
    const scheduleTarget = target
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
        target = target.series
    }
    if(initProps?.waitlist) {
        const now = moment()
        const relevantProp = initProps.waitlist?.props.find(prop => {
            const date = moment(prop.date)
            if(date.isSameOrAfter(now, 'date')) {
                if(prop.time_to) {
                    const propTime = moment(`${prop.date} ${prop.time_to}`, `${dbDateFormat} ${dbTimeFormat}`)
                    return propTime.isSameOrAfter(now)
                } else {
                    return true
                }
            }
        })
        waitlist = {...initProps?.waitlist, firstProp: relevantProp}
        selectedTime = relevantProp?.time_from && moment(`${relevantProp.date} ${relevantProp.time_to}`, `${dbDateFormat} ${dbTimeFormat}`).isSameOrAfter(now) ? relevantProp?.time_from : now.clone().minutes(Math.ceil(now.minutes() / 5) * 5).seconds(0).format(dbTimeFormat)
        selectedDay = moment(relevantProp?.date, dbDateFormat).day()
        eventDateTime = {date: relevantProp?.date, end: selectedTime ? moment(selectedTime, dbTimeFormat).add(relevantProp?.box_category?.length ?? 60, 'minute').format(dbTimeFormat) : null}
    }
    let values = {
        waitlist_id: waitlist?.id ?? null,
        box_category_fk: target?.box_category_fk ?? waitlist?.firstProp?.box_categories_id ?? null,
        coach_fk: target?.coach_fk ?? target?.coach?.user_fk ?? initProps?.coach_fk ?? waitlist?.firstProp?.coach?.user_fk ?? null,
        locations_box_fk: target?.locations_box_fk ?? target?.location_fk ?? waitlist?.locations_box_id ?? null,
        spaces_id: target?.spaces_id ?? initProps?.spaces_id ?? null,
        season_id: target?.season_id ?? initProps?.season_id ?? null,
        scheduleTarget: scheduleTarget ?? null,
        spaces_relation: fromAvailability ? null : getSpacesRelationForEdit(scheduleTarget),
        ...(fromAvailability ? getAvailabilityConfigInitialValues(target, eventDateTime, selectedDay) : getRepeatInitialValues(scheduleTarget, eventDateTime, selectedTime, selectedDay, flowName))
    }
    if (!editType && hasLimitedCoachViewSchedule()) {
        values.coach_fk = store.getState().user?.user?.user_fk;
    }
    if(fromAvailability) {
        values.availability_id = target?.availability_id ?? target?.id
    }
    return values;
}

const getExportInitialValues = () => {
    return {
        location_fk: null,
        file_type: 2,
        new_only: false,
        exclude_deposite: false,
        month: moment().month() + 1,
        year: moment().year(),
        email_to: null,
        reference_date: null,
        general_sort: 999,
        general_cust: 9999,
        include_mtc: false,
        heshing: false,
        download_customers: false,
        include_payment_reference: false,
        export_profit_centers: false,
        journal_entries_mode: 'customer_cards',
        epr_file_type: 'csv',
        export_to: 'movFile'
    }
}

const getSendInvoicesReportInitialValues = () => {
    const financeAccountantEmail = store.getState().userSettings.financeAccountantEmail
    const userEmail = store.getState().user.user.email

    return {
        csv: true,
        pdf: false,
        email: financeAccountantEmail || '',
        bcc: userEmail || ''
    }

}

const getExportValidationSchema = () => {
    return yup.object().shape({
        location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        file_type: yup.number().oneOf([1,2,4,5]).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        new_only: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        exclude_deposite: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        include_mtc: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        heshing: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        download_customers: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        month: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        year: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        email_to: yup.string().when('export_to', {
            is: value => value === 'email',
            then: (schema) => schema.email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
                return !validateAfterEmailSymbol(value);
            }),
            otherwise: (schema) => schema.nullable()
        }),
        reference_date: yup.string().nullable(),
        journal_entries_mode: yup.string().oneOf(['income_accounts', 'customer_cards']).required(t('thisFieldIsMandatory')),
        epr_file_type: yup.string().oneOf(['csv', 'xlsx']).required(t('thisFieldIsMandatory')),
        export_to: yup.string()
    })
}

const getSendInvoicesValidationSchema = () => {
    return yup.object().shape({
        pdf: yup.boolean(),
        csv: yup.boolean().test('csv', t('select-at-least-1-export-option'), function(value){
            return this.parent.pdf || value
        }),
        email: yup.string().email(t('emailIsInvalid')).required(t('thisFieldIsMandatory')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }),
        bcc: yup.string().nullable().email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !value || !validateAfterEmailSymbol(value);
        })
    })
}

const getBuildUniformReportValidationSchema = () => {
    return yup.object().shape({
        report_type: yup.string().required(),
        tax_year: yup.string().nullable().when('report_type', {
            is: 'tax_year',
            then: (schema) => schema.required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            otherwise: (schema) => schema.nullable(),
        }),
        from_date: yup.string().nullable().when('report_type', {
            is: 'date_range',
            then: (schema) => schema.required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            otherwise: (schema) => schema.nullable(),
        }),
        to_date: yup.string().nullable().when('report_type', {
            is: 'date_range',
            then: (schema) => schema.required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')).test('date-range', t('date-range-error'), function (value) {
                if (!value || !this.parent.from_date) return true;
                return moment(value, dbDateFormat).isSameOrAfter(moment(this.parent.from_date, dbDateFormat), 'day');
            }),
            otherwise: (schema) => schema.nullable(),
        }),
        location_box: yup.number().nullable().test('location-required', t('thisFieldIsMandatory'), function (value) {
            const locationsByRivhitId = store.getState().box.box?.locationsByRivhitId;
            const locationOptions = getLocationsByRivhitIdOptions(locationsByRivhitId);
            if (locationOptions.length <= 1) return true;
            return value != null && value > 0;
        }),
    });
};

const getSendDoctorJournalReportValidationSchema = () => {
    return yup.object().shape({
        coach_ub_id: yup.number().positive(t('thisFieldIsMandatory')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        fromDate: yup.string().required(t('thisFieldIsMandatory')),
        toDate: yup.string().required(t('thisFieldIsMandatory')).test('date-range', t('date-range-error'), function (value) {
            if (!value || !this.parent.fromDate) return true;
            return moment(value, dbDateFormat).isSameOrAfter(moment(this.parent.fromDate, dbDateFormat), 'day');
        }),
        csv: yup.boolean(),
        pdf: yup.boolean().test('exportType', t('select-at-least-1-export-option'), function (value) {
            return this.parent.csv || !!value;
        }),
        primaryEmail: yup.string().email(t('emailIsInvalid')).required(t('thisFieldIsMandatory')).test('email-domains', t('invalidEmailDomain'), (value) => !validateAfterEmailSymbol(value)),
        bcc: yup.string().nullable().email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), (value) => !value || !validateAfterEmailSymbol(value)),
        declarationAccepted: yup.boolean().oneOf([true], t('thisFieldIsMandatory'))
    })
}

const getSendDoctorJournalReportInitialValues = (initProps) => {
    const params = initProps?.params ?? store.getState().stepper?.props?.initProps?.params;
    const user = store.getState().user?.user;
    return {
        coach_ub_id: params?.coach_ub_id ?? null,
        fromDate: params?.fromDate ?? moment().startOf('day').format(dbDateFormat),
        toDate: params?.toDate ?? moment().endOf('day').format(dbDateFormat),
        hideClientName: false,
        csv: true,
        pdf: false,
        primaryEmail: '',
        bcc: user?.email || '',
        declarationAccepted: false
    }
}

const getBasicInfoValidationSchema = (target) => {
    const calendarType = store.getState().schedule?.calendarType
    const spacesRelationSchema = yup.array().nullable().of(yup.object().shape({ id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))}))

    return yup.object().shape({
        box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        coach_fk: yup.number().positive().nullable(),
        second_coach_fk: yup.number().positive().nullable(),
        locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
        season_id: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
        max_users: yup.number().min(0).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        customFields: getCustomFieldValueValidationSchema(target),
        spaces_relation: spacesRelationSchema
    })
}

const getUserAndMembershipValidationSchema = () => {
    const editType = store.getState().stepper.editType
    let additionsValidationObject = yup.object().shape({})
    if(!editType) {
        additionsValidationObject = yup.object().shape({
            scheduleUser: yup.object().shape({
                membership_user_fk: yup.number().positive()
                    .when(['isLead', 'paymentObject', 'isNoMembership'], (isLead, paymentObject, isNoMembership) => (isLead === false && paymentObject === null && isNoMembership === false) ? yup.number().positive().required(t('thisFieldIsMandatory')) : yup.number().nullable()),
                paymentObject: yup.object().shape({
                    cart: yup.object().shape({}).required(),
                    method: yup.string().oneOf([ENTER_DEBT, FREE_PURCHASE])
                }).nullable(),
                force: yup.boolean().required(),
                sendInvitation: yup.boolean().required(),
                isNoMembership: yup.boolean().required()
            }),
        })
    }
    const basicValidationObject = yup.object().shape({
        live_link: yup.string().nullable(),
        customFields: getCustomFieldValueValidationSchema()
    })

    return basicValidationObject.concat(additionsValidationObject)
}

const getNoteValidationSchema = () => {
    const flowName = store.getState().stepper?.name
    let basicSchema = yup.object().shape({
        id: yup.number().nullable(),
        text: yup.string().required(t('thisFieldIsMandatory')).test(
            'has-content',
            t('thisFieldIsMandatory'),
            (value) => {
                if (!value) return false;
                const textOnly = value.replace(/<[^>]*>/g, '').trim();
                return textOnly !== '';
            }
        ),
    })
    switch (flowName) {
        case flowOptions.USER_NOTE:
            return basicSchema.concat(yup.object().shape({
                message_template_id: yup.number().nullable(),
                schedule_id: yup.number().nullable(),
                users_id: yup.number().required(),
                pin: yup.boolean()
            }))
        case flowOptions.SCHEDULE_NOTE:
            return basicSchema.concat(yup.object().shape({
                schedule_id: yup.number().nullable(),
                series_id: yup.number().nullable(),
                isSingle: yup.boolean().when(['fromCreateEvent'], {
                    is: (fromCreateEvent) => fromCreateEvent === true,
                    then: yup.boolean().nullable(),
                    otherwise: yup.boolean().required()
                }),
                fromCreateEvent: yup.boolean()
            }))
        default:
            return basicSchema;
    }
}

const getNoteInitialValues = ({target, ogInitProps}) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? ogInitProps;

    let basic = {
        id: target?.id ?? null,
        message_template_id: target?.message_template_id ?? null,
        text: target?.text ?? '',
    }

    switch (flowName) {
        case flowOptions.USER_NOTE:
            return {...basic,
                users_id: initProps?.users_id,
                schedule_id: target?.relatable_id ?? initProps?.schedule_id ?? null,
                pin: !!target?.pin,
                lastNoteText: initProps?.lastNoteText ?? null,
                fileInfo: {files: (target?.files ?? []).map((file) => ({...file, shouldRemove: false})), form_type_id: null}
            }
        case flowOptions.SCHEDULE_NOTE:
            if(editType) {
                return {
                    ...basic,
                    editType,
                    series_id: initProps.scheduleTarget.series_fk,
                    schedule_id: initProps.scheduleTarget.id,
                    isSingle: editType !== SERIES_FUTURE_SESSIONS_EDIT_TYPE,
                    actionType: initProps.actionType ?? 'edit',
                    check_in: initProps.scheduleTarget.scheduleNote?.check_in
                }
            } else {
                return {
                    ...basic,
                    // series_id: target?.relatable_id && target?.relatable_type?.toLowerCase().includes('series') ? target?.relatable_id : (initProps?.series_id ?? null),
                    // schedule_id: target?.relatable_id && target?.relatable_type?.toLowerCase().includes('schedule') ? target?.relatable_id : (initProps?.schedule_id ?? null),
                    series_id: initProps?.series_id ?? null,
                    schedule_id: initProps?.schedule_id ?? null,
                    isSingle: initProps?.isSingle,
                    fromCreateEvent: initProps?.fromCreateEvent,
                }
            }
        default:
            return basic;
    }
}

const getBasicInfoAppointmentValidationSchema = () => {
    const flowName = store.getState().stepper?.name
    const calendarType = store.getState().schedule?.calendarType
    const editType = store.getState().stepper.editType
    const spacesRelationSchema = yup.array().nullable().of(yup.object().shape({ id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))}))
    const fromAvailability = [flowOptions.APPOINTMENT_WITH_AVAILABILITY, flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY].includes(flowName)
    let basicValidationObject = yup.object().shape({
        box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
    }).concat(fromAvailability ? getAvailabilityConfigValidationSchema() : getRepeatConfigValidationSchema())

    if(editType) {
        basicValidationObject = basicValidationObject.concat(yup.object().shape({
            bookedUser: yup.object().shape({
                user_fk: yup.number().positive()
            })
        }))
    } else {
        basicValidationObject = basicValidationObject.concat(yup.object().shape({
            scheduleUser: yup.object().shape({
                user_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')).integer(),
                isLead: yup.boolean().required(),
            })
        }))
    }
    let additionsValidationObject = yup.object().shape({})
    console.log('flow name', flowName)
    switch (flowName) {
        case flowOptions.APPOINTMENT_BASIC:
            additionsValidationObject = yup.object().shape({
                coach_fk: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
                spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
                spaces_relation: spacesRelationSchema
            })
            break;
        case flowOptions.APPOINTMENT_WITH_AVAILABILITY:
            additionsValidationObject = yup.object().shape({
                coach_fk: yup.number().positive().required(),
                availability_id: yup.number().positive().required(),
            })
            break;
        case flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY:
            additionsValidationObject = yup.object().shape({
                spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
                availability_id: yup.number().positive().required(),
            })
            break;
    }
    return basicValidationObject.concat(additionsValidationObject)
}


const getFlowFormManageInitialValues = ({ogInitProps}) => {
    const appointmentFormSettings = store.getState().box.box.settings?.[APPOINTMENT_MANAGEMENT_FORM]
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? ogInitProps
    const existingAppointmentFormSetting = appointmentFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)
    return {
        appointmentType: {
            id: existingAppointmentFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            displayMode: existingAppointmentFormSetting?.properties?.displayMode ?? 'none',
            box_categories: existingAppointmentFormSetting?.properties?.box_categories ?? [],
        },
    }
}

const getFlowFormInitialValues = ({target, ogInitProps}) => {
    const hugimFormSettings = store.getState().box.box.settings?.[HUGIM_FORM]
    const groupFormSettings = store.getState().box.box.settings?.[GROUP_FORM]
    const appointmentFormSettings = store.getState().box.box.settings?.[APPOINTMENT_FORM]
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? ogInitProps;
    const existingHugimFormSetting = hugimFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)
    const existingGroupFormSetting = groupFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)
    const existingAppointmentFormSetting = appointmentFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)
    return {
        hugimType: {
            id: existingHugimFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            hugim: existingHugimFormSetting?.properties?.hugim ?? [],
            allowTrial: existingHugimFormSetting?.properties?.allowTrial ?? false,
        },
        groupType: {
            id: existingGroupFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            box_categories: existingGroupFormSetting?.properties?.box_categories ?? [],
            allowTrial: existingGroupFormSetting?.properties?.allowTrial ?? false,
        },
        appointmentType: {
            id: existingAppointmentFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            box_categories: existingAppointmentFormSetting?.properties?.box_categories ?? [],
            allowTrial: existingAppointmentFormSetting?.properties?.allowTrial ?? false,
        },
    }
}

const updateSelectionTree = (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if(tempSelection) dispatch(addToSelectionsTree(tempSelection))
}

const memberDetailsOnNext = (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if (tempSelection) {
        dispatch(isEmailAvailable(tempSelection))
    }
}

const convertLeadOnNextStep = async (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if(tempSelection) {
        dispatch(checkEmailChange({tempSelection}))
    }
}

const checkTrackSelection = (dispatch, onSave) => {
    const tempSelection = store.getState().stepper.tempSelection;
    if (!tempSelection?.canProceed) {
        dispatch(openModal({
            modalName: STEPPER_CONFIRM_MODAL,
            props: {
                header: t('choose-track-error-header'),
                subheader: t('choose-track-error-subheader'),
                hideConfirmButton: true,
            },
        }));
        return;
    }
    updateCurrentStep(dispatch, onSave);
}

const checkTrackCoursesSelection = (dispatch, onSave) => {
    const tempSelection = store.getState().stepper.tempSelection;
    if (!tempSelection?.canProceed) {
        dispatch(openModal({
            modalName: STEPPER_CONFIRM_MODAL,
            props: {
                header: t('confirm-track-registration-header'),
                subheader: t('session-per-week-error', {session_per_week: tempSelection.session_per_week}),
                hideConfirmButton: true,
                hideCancelButton: true
            },
        }));
        return;
    }
    if (tempSelection?.hasFullSelectedEvents) {
        dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL, props: {
            isNotError: false,
            header: t('areYouSure'),
            subheader: t('track-selected-activity-full-confirm'),
            onConfirm: () => {
                dispatch(setLoadingModal({modalName: STEPPER_CONFIRM_MODAL, isConfirmLoading: true}))
                updateCurrentStep(dispatch, onSave)
            },
            onCancel: () => dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL})),
        }}));
        return;
    }
    updateCurrentStep(dispatch, onSave);
}

const checkHugBookingRestrictionsOnBookToHugDetailsStep = (dispatch, onSave) => {
    const flowName = store.getState().stepper?.name
    if (flowName === flowOptions.BOOK_TO_HUG_FLOW || flowName === flowOptions.BOOK_TO_HUG_CREATE_LEAD) {
        return checkHugBookingRestrictions(dispatch, () => updateCurrentStep(dispatch, onSave))
    }
    updateCurrentStep(dispatch, onSave)
}

const checkHugBookingRestrictions = async (dispatch, onSuccess) => {
    const tempSelection = store.getState().stepper.tempSelection
    const payload = tempSelection?.user_fk
    ? {user_fk: tempSelection.user_fk, ...(tempSelection.birthday ? {birthday: tempSelection.birthday} : {})}
    : {birthday: tempSelection?.birthday}
    if (!tempSelection) {
        onSuccess(dispatch)
        return
    }
    try {
        await fetchApi('hugim/checkBookingRestrictions', 'post', {series_id: tempSelection.series_id, ...payload}, false, true);
        onSuccess(dispatch)
    } catch (e) {
        dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL, props: {
            isNotError: false,
            header: t('areYouSure'),
            subheader: `${getMessageToUserFromError(e.error)} \n${t('book-anyway-question')}`,
            onConfirm: () =>{
                dispatch(setLoadingModal({modalName: STEPPER_CONFIRM_MODAL, isConfirmLoading: true}))
                onSuccess(dispatch)
            },
            onCancel: () => dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL}))            }}))
    }
}

const checkSlotStillOpen = async ({dispatch, onSave, values}) => {
    const open = await fetchApi('availability/checkSlot', 'post', {
        availability_id: values.availability_id,
        date: values.date,
        time: values.time,
        box_categories_id: values.box_category_fk
    }, false, true);
    if(open) {
        checkDateTimeLimitations(dispatch, onSave)
    } else {
        dispatch(setError('slot-no-longer-available'))
    }
}

const checkDateTimeLimitations = async (dispatch, onSave) => {
    try {
        const tempSelection = store.getState().stepper.tempSelection
        if (tempSelection?.spaces_id?.length || tempSelection?.coach_id || tempSelection?.second_coach_id) {
            const res = await fetchApi('spaces/checkScheduleDateTimeOpen', 'POST', tempSelection, false, true);
            if (res.length || Object.values(res ?? {}).some(val => val > 0)) {
                const box = store.getState().box.box;
                const timeFormat = box ? box.locations_box[0].time_format : null
                const dateFormat = box ? box.locations_box[0].date_format : null
                let params = {
                    date: moment(tempSelection.date, dbDateFormat).format(dateFormat),
                    start_time: moment(tempSelection.start_time, dbTimeFormat).format(timeFormat),
                    end_time: moment(tempSelection.end_time, dbTimeFormat).format(timeFormat),
                }
                const blockType = getDateTimeBlockType(res)
                dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL,
                    props: {
                        header: t('areYouSure'),
                        subheader: t(`${blockType}UnavailableTimeWarning`, params),
                        onConfirm: () => updateCurrentStep(dispatch, onSave)
                    }
                }))
            } else {
                updateCurrentStep(dispatch, onSave)
            }
        } else {
            updateCurrentStep(dispatch, onSave)
        }
    } catch (error) {
        console.log('error',error)
        updateCurrentStep(dispatch, onSave)
    }
}

export const getDateTimeBlockType = (checkRes) => {
    let blockType = 'space'
    if(typeof checkRes !== 'object') return blockType // just for fallback because it used to be an array returned from the server
    if(checkRes?.spaceScheduleCount && (checkRes?.coachScheduleCount || checkRes?.secondCoachScheduleCount)) {
        blockType = 'spaceCoach'
    } else if(checkRes?.coachScheduleCount || checkRes?.secondCoachScheduleCount) {
        blockType = 'coach'
    }
    return blockType
}

const updateCurrentStep = (dispatch, onSave) => {
    dispatch(updateTempSelection(null))
    dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL}));
    const flowConfig = store.getState().stepper
    const stepIndex = flowConfig.steps.indexOf(flowConfig?.currStep);
    if(flowConfig.steps[stepIndex + 1] !== optionalSteps.SUCCESS_PAGE) {
        dispatch(updateCurrStep(flowConfig.steps[stepIndex + 1]))
    } else {
        onSave()
    }
}

const getRepeatConfigValidationSchema = () => {
    const isEdit = store.getState().stepper.editType
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function(value){
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        end_time: yup.string().required(t('thisFieldIsMandatory')).when(['time'], (time, schema) => {
            const start = moment(time, dbTimeFormat)
            return schema.test({
                test: end => moment(end, dbTimeFormat).isAfter(start),
                message: t('shiftTimeError')
            })
        }).test('time-format', 'invalid time', function(value){
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        repeatConfig: yup.object().when([], {
            is: () => isEdit === null,
            then: yup.object().shape({
                repeat: yup.boolean().required(t('thisFieldIsMandatory')),
                type: yup.string().nullable().when(['repeat'], (repeat_val, schema) => {
                    return schema.test({
                        test: type => repeat_val ? ['forever', 'until', 'times'].includes(type) : true,
                        message: 'invalid type'
                    })
                }),
                until: yup.string().nullable().when(["type", "repeat"], {
                    is: (type, repeat) => {
                        console.log('type, repeat', type, repeat)
                        return repeat && type === 'until'
                    },
                    then: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    })
                }),
                times: yup.number().nullable().when("type", {
                    is: 'times',
                    then: yup.number().nullable().when('repeat', {
                        is: true,
                        then: yup.number(t('onlyWhole')).integer(t('onlyWhole')).required(t('thisFieldIsMandatory')).min(2, t('minimumTwoSessions')).max(104).typeError(t('thisFieldIsMandatory'))
                        .test('multi-days', t('multiDaysTimesError'), function (value) {
                            return this.parent?.type !== 'times' || this.parent?.days?.length === 1
                        }),
                    }),
                }),
                days: yup.array().of(yup.number().min(0).max(6)).min(1, t('one-day-minimum')),
                seriesName: yup.string().nullable()
            }),
            otherwise: yup.object().nullable().notRequired()
        })
    })
}

const getAvailabilityConfigValidationSchema = () => {
    const isEdit = store.getState().stepper.editType
    if(isEdit) {
        return yup.object().shape({
            date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
                return moment(value, dbDateFormat).format(dbDateFormat) === value
            }),
            time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            end_time: yup.string().required(t('thisFieldIsMandatory')).when(['time'], (time, schema) => {
                const start = moment(time, dbTimeFormat)
                return schema.test({
                    test: end => moment(end, dbTimeFormat).isAfter(start),
                    message: t('shiftTimeError')
                })
            }).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            })
        })
    } else return getRepeatConfigValidationSchema()
}


const getMessageDetailsValidationSchema = () => {
    return yup.object().shape({
        class_name: yup.string().oneOf(messageAudience).required(t('thisFieldIsMandatory')),
        users: yup.array(yup.object().shape({
            user_fk: yup.number().positive(),
        })).when('class_name', {
            is: value => value === 'ReportMessage' || value === 'PrivateMessage',
            then: yup.array().test('required', t('thisFieldIsMandatory') ,(value) => value?.filter(u => u.isSelected)?.length)
        }).when(['type', 'class_name'], {
            is: (type, class_name) => type === EMAIL && class_name === 'PrivateMessage',
            then: yup.array(yup.object().test('is-email', t('user-must-have-an-email'), (value) => value.email || [1,6,8].includes(value.child)))
        }).when(['type', 'class_name'], {
            is: (type, class_name) => (type === SMS || type === WHATSAPP) && class_name === 'PrivateMessage',
            then: yup.array(yup.object().test('is-phone', t('user-must-have-a-phone-number'), (value) => value.phone || [1,6,8].includes(value.child) || value.additional_phone))
        }),
        locations_box_fk: yup.number(),
        senderID: yup.string().nullable().when('type', {
            is: EMAIL,
            then: yup.string().nullable().email(t('sender-email-is-invalid')).required(t('thisFieldIsMandatory'))
            .test('sender' ,t('sender-email-is-invalid'), (value) => !validateAfterEmailSymbol(value))
        }).when('type', {
            is: SMS,
            then: yup.string().nullable().required(t('thisFieldIsMandatory'))
            .test('sender', t('sender-is-invalid'), (value) => /^[a-zA-Z0-9]{1,11}$/g.test(value))
            .test('verified', t('sender-must-be-verified'), function (value) {
                return (this.parent.verifiedSenderID && this.parent.verifiedSenderID === value) || !/^\d+$/.test(this.parent.senderID)
            })
        }),
        verifiedSenderID: yup.string().nullable(),
        messageContent: yup.string().required(t('thisFieldIsMandatory')),
        message_array: yup.array(yup.object().shape({
            text: yup.string(),
            key: yup.string(),
            keyDB: yup.string(),
        })),
        subject: yup.string().when('type', {
            is: EMAIL,
            then: yup.string().required(t('thisFieldIsMandatory'))
        })
    })
}

const getAppointmentWaitlistAddValidationSchema = () => {
    return yup.object().shape({
        users_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        box_category_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        locations_box_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        coach_ub_id: yup.number().nullable(),
        from: yup.string().required(t('thisFieldIsMandatory'))
            .test('date-format', t('thisFieldIsMandatory'), (value) => moment(value, dbDateFormat, true).isValid())
            .test('not-past', t('thisFieldIsMandatory'), (value) => !moment(value, dbDateFormat).isBefore(moment(), 'day')),
        to: yup.string().required(t('thisFieldIsMandatory'))
            .test('date-format', t('thisFieldIsMandatory'), (value) => moment(value, dbDateFormat, true).isValid())
            .test('after-from', t('appointment-waitlist-to-after-from'), function (to) {
                return !this.parent.from || !to || moment(to, dbDateFormat).isSameOrAfter(moment(this.parent.from, dbDateFormat), 'day')
            })
            .test('max-30', t('appointment-waitlist-date-range-max'), function (to) {
                return !this.parent.from || !to || moment(to, dbDateFormat).diff(moment(this.parent.from, dbDateFormat), 'days') <= 30
            }),
        timeRange: yup.array().of(
            yup.object().shape({
                from: yup.string().required(t('thisFieldIsMandatory')),
                to: yup.string().required(t('thisFieldIsMandatory'))
                    .test('to-after-from', t('appointment-waitlist-to-after-from'), function (to) {
                        return !this.parent.from || !to || to > this.parent.from
                    }),
            })
        ).nullable().max(3).test('no-overlap', t('appointment-waitlist-range-overlap'), (ranges) => {
            if (!ranges?.length) return true
            const sorted = [...ranges].filter(range => range?.from && range?.to).sort((a, b) => a.from.localeCompare(b.from))
            for (let i = 1; i < sorted.length; i++) {
                if (sorted[i].from <= sorted[i - 1].to) return false
            }
            return true
        }),
    })
}

const getAppointmentWaitlistAddInitialValues = (initProps) => {
    const user = initProps?.user ?? null
    const today = moment().format(dbDateFormat)
    return {
        user,
        users_id: user?.user_fk ?? null,
        box_category_id: null,
        coach_ub_id: null,
        locations_box_id: store.getState().userSettings.scheduleLocation?.id ?? null,
        dateMode: 'specific',
        from: today,
        to: today,
        timeRange: null,
    }
}

export const conditionalUserDetailsSchema = (schema, boxSettings, field, userType) => {
    if (userType === 'groupMember' && boxSettings?.[field]?.memberRequired) {
        return schema.test('required', t('thisFieldIsMandatory'), function (value, data) {
            return value || !data?.options?.context?.head;
        })
    }
    if (boxSettings?.[field]?.[`${userType}Required`]) {
        return schema.required(t('thisFieldIsMandatory'))
    }
    return schema
}

// userType in {'member', 'lead', 'staff_member', undefined}
const getUserDetailsBaseValidationSchema = (userType) => {
    const boxSettings = store.getState().box.box.settings?.[USER_FIELDS]
    const flowName = store.getState().stepper.name
    userType = userType || flowName?.toLowerCase();

    const commonSchema = {
        first_name: yup.string().required(t('thisFieldIsMandatory')),
        last_name: conditionalUserDetailsSchema(yup.string(), boxSettings, 'last_name', userType),
        email: conditionalUserDetailsSchema(yup.string().nullable(true).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }), boxSettings, 'email', userType),
        phone: conditionalUserDetailsSchema(yup.string(), boxSettings, 'phone', userType),
        birthday: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'birthday', userType),
        gender: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'gender', userType),

    };
    switch (flowName) {
        case flowOptions.BOOK_TO_HUG_FLOW:
        case flowOptions.BOOK_TO_HUG_CONVERT_LEAD:
        case flowOptions.TRACK_REGISTRATION:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                phone: commonSchema.phone.nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
                .min(5, t('min-chars', {min: 5})),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                personal_id: conditionalUserDetailsSchema(yup.string().nullable(true).matches(/^[0-9]*$/, t('numbers-only')).test('length-test', t('personal-id-length-error'), val => {
                    let id = String(val).trim();
                    if(val === null || val === '') return true
                    return !(id.length > 9 || id.length < 5);
                }), boxSettings, 'personal_id', userType),
                emailValidated: yup.boolean().when('email', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                personalIdValidated: yup.boolean().when('personal_id', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                phoneValidated: yup.boolean().when('phone', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                rfid: yup.number().nullable(true),
                invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                customFields: getCustomFieldValueValidationSchema(),
                ...(flowName === flowOptions.BOOK_TO_HUG_CONVERT_LEAD && {lead_id: yup.number().required()})

            })
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                phone: commonSchema.phone.nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
                    .min(5, t('min-chars', {min: 5})),
                emailValidated: yup.boolean().when('email', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                phoneValidated: yup.boolean().when('phone', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                status_fk: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                source_fk: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'source_fk', userType),
                users_boxes_owner_id: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'users_boxes_owner_id', userType),
                invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
                comment: yup.string().nullable(true),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                customFields: getCustomFieldValueValidationSchema()
            })
        case flowOptions.LEAD:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                status_fk: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                source_fk: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'source_fk', userType),
                users_boxes_owner_id: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'users_boxes_owner_id', userType),
                city: conditionalUserDetailsSchema(yup.string(), boxSettings, 'city', userType),
                address: conditionalUserDetailsSchema(yup.string(), boxSettings, 'address', userType),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                comment: yup.string().nullable(true),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                customFields: getCustomFieldValueValidationSchema()
            })
        case flowOptions.STAFF_MEMBER:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.mixed().required(t('thisFieldIsMandatory'))
                    .test('staff-location', t('thisFieldIsMandatory'), (value) => value === 'all' || (typeof value === 'number' && value > 0)),
                personal_id: yup.string(),
                additional_phone: yup.string().nullable(true),
                properties: yup.object().shape({
                    voice_center: yup.object().shape({
                        phone: yup.string().nullable(true)
                    }),
                    employee: yup.object().shape({
                        license_id: yup.string().nullable(true).matches(/^[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, t('non-numeric-chars'))
                    })
                })
            })
        case flowOptions.CONNECT_USER_TO_GROUP:
            return yup.object().shape({
                ...commonSchema,
                last_name: yup.string().required(t('thisFieldIsMandatory')),
                personal_id: conditionalUserDetailsSchema(yup.string().nullable(true)),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
            })
        default:
            return yup.object().shape(commonSchema)
    }
}

const courseChildDetailsValidationSchema = () => {
    const boxSettings = store.getState().box.box.settings?.[USER_FIELDS]
    return yup.object().shape({
        first_name: yup.string().required(t('thisFieldIsMandatory')),
        last_name: yup.string().required(t('thisFieldIsMandatory')),

        locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
        phone: conditionalUserDetailsSchema(
            yup.string().nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
                .min(5, t('min-chars', {min: 5})),
            boxSettings, 'phone', 'child'
        ),
        email: conditionalUserDetailsSchema(
            yup.string().nullable(true).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
                return !validateAfterEmailSymbol(value);
            }),
            boxSettings, 'email', 'child'
        ),
        birthday: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'birthday', 'child'),
        gender: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'gender', 'child'),
        personal_id: conditionalUserDetailsSchema(
            yup.string().nullable(true).matches(/^[0-9]*$/, t('numbers-only')).test('length-test', t('personal-id-length-error'), val => {
                let id = String(val).trim();
                if(val === null || val === '') return true
                return !(id.length > 9 || id.length < 5);
            }),
            boxSettings, 'personal_id', 'child'
        ),
        emailValidated: yup.boolean().when('email', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        personalIdValidated: yup.boolean().when('personal_id', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        phoneValidated: yup.boolean().when('phone', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        rfid: yup.number().nullable(true),
        invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
        allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
        allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
        customFields: getCustomFieldValueValidationSchema(),
    })
}

const getRequiredFieldsSettingsValidationSchema = () => {
    const flowConfig = store.getState().stepper
    const type = flowConfig.props?.initProps?.type
    if (!type || !boxSettingsProps[type]) return null;
    return yup.object().shape({
        properties: yup.object().shape({
            ...boxSettingsProps[type].fields.reduce((accField, currField) => ({
                ...accField,
                [currField]: yup.object().shape({
                    ...boxSettingsProps[type].flows.reduce((accFlow, currFlow) => ({
                        ...accFlow,
                        [`${currFlow}Required`]: yup.boolean()
                    }), {})
                })
            }), {})
        })
    })
}

const getUserChargeSettingValidationSchema = () => {
    const flowConfig = store.getState().stepper
    const paymentProvider = flowConfig.props?.initProps?.paymentProvider
    if(!paymentProvider) return yup.object().shape({})
    return yup.object().shape({
        properties: yup.object().shape({
            ...siteChargeOptions[paymentProvider].reduce((acc,charge) => (
                {
                    ...acc,
                    [charge]: yup.object().shape({
                        site: yup.boolean(),
                        app: yup.boolean()
                    })
                }), {})
        })
    })
}

const getAccountCardsSettingsValidationSchema = () => {
    return yup.object().shape({
        locationId: yup.number().nullable(),
        customer_management_type: yup.number().oneOf([1, 2]).nullable(),
        initial_customer_management_type: yup.number().nullable(),
        has_foreign_numbers: yup.boolean().nullable(),
        branch_account_numbers: yup.array().nullable(),
        show_branch_customer_cards: yup.boolean().nullable(),
        transaction_types: yup.array().of(yup.object().shape({
            type_key: yup.string().required(),
            document_type: yup.number().nullable(),
            is_document: yup.boolean().nullable(),
            code: yup.string().nullable().transform((value) => (value == null ? value : String(value))).test(
                'transaction-type-code-format',
                t('journal-export-transaction-type-code-invalid'),
                (value) => !value || /^[\p{L}\p{N}]{1,3}$/u.test(value),
            ),
        })).nullable(),
        initial_transaction_types: yup.array().nullable(),
        cards: yup.array().of(yup.object().shape({
            id: yup.mixed().required(),
            account_number: yup.string().nullable(),
            is_new: yup.boolean().nullable(),
            name: yup.string().nullable().test('required-if-name-editable', t('thisFieldIsMandatory'), function (value) {
                return !!value?.trim();
            }),
        })),
    })
}

const getUserNoteExportValidationSchema = () => {
    return yup.object().shape({
        subject: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory')),
        email_to: yup.string().required(t('thisFieldIsMandatory')).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }),
        note_relation_id: yup.number().required(),
    })
}

const getPromoCodeValidationSchema = () => {
    return yup.object().shape({
        name: yup.string().trim().required(t('requiredField')).max(20).test('unique-name', t('unavailablePromoCodeName'),
            function (value) {
                if (!value) return true
                const location_id = this.parent?.location_id
                const target = store.getState().modalManager[CREATE_EVENT_MODAL]?.props?.target
                const promoCodes = store.getState().box.box.promoCodes
                if (target && target.name === value) return true
                const flat = Object.values(promoCodes ?? {}).flat()
                return !flat.some(c => c.name === value && c.location_id === location_id)
            }),
        location_id: yup.number().nullable(),
        expiration_date: yup.string().nullable(),
        limit_quantity: yup.number().nullable().min(1).max(10),
        discount_amount: yup.number().nullable().when('tiered_promo_codes', {
            is: (val) => val === null,
            then: yup.number()
                .typeError(t('requiredField'))
                .required(t('requiredField'))
                .min(1, t('promoCodeDiscountInvalidDiscount'))
                .max(100, t('promoCodeDiscountInvalidDiscount')),
            otherwise: yup.number().nullable()
        }),
        recurring_cycles: yup.number().nullable().min(0).max(12),
        tiered_promo_codes: yup.array().nullable().of(
            yup.object().shape({
                discount_amount: yup.number()
                    .typeError(t('requiredField'))
                    .required(t('requiredField'))
                    .min(1, t('promoCodeDiscountInvalidDiscount'))
                    .max(100, t('promoCodeDiscountInvalidDiscount')),
                cycle: yup.number()
            })
        ),
        membership_types: yup.array(),
        staff: yup.array().of(yup.string().oneOf(InternalPromoRoleOptions)).nullable()
    })
}

const siteLeadFormSettingsValidationSchema = () => {
    let validationSchema = {}
    siteFormLeadFieldOptions.forEach((field) => {
        validationSchema[field] = yup.object().shape({
            required: yup.boolean()
        })
    })
    return yup.object().shape({
        status_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
        source_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
        show_in_site: yup.boolean().typeError(t('thisFieldIsMandatory')),
        ...validationSchema

    })
}

const skipMetaWhatsappLinkTagValidation = (parent) => {
    const hasMetaWhatsapp = store.getState().box?.box?.integrations?.some((i) => i.name === 'metaWhatsapp');
    return hasMetaWhatsapp
        && parent.send_whatsapp
        && parent.message_template_id
};
const getSendMembershipLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        available_on_app: yup.boolean().required(t('thisFieldIsMandatory')),
        item_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        item_type: yup.string().nullable(),
        message_template_id: yup.number().nullable(),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function () {
                if (skipMetaWhatsappLinkTagValidation(this.parent)) return true;
                return this.parent.message_content?.includes(`[${t('link-to-membership')}]`)
            }),
    }))
}

const getGeneralLinkValidationSchema = () => {
    return yup.object().shape({
        user_fk: yup.number().when('type', {
            is: undefined,
            then: yup.number().required(t('thisFieldIsMandatory')).test('user_has_phone_email', t('user-must-have-a-phone-number-and-email'), function (value) {
                const isGroupMember = [1, 6, 8].includes(this.parent.child)
                const phoneOk = this.parent.phone || this.parent.additional_phone || isGroupMember
                const emailOk = this.parent.email || isGroupMember
                return (this.parent.send_whatsapp || this.parent.send_sms) && this.parent.send_email
                    ? phoneOk && emailOk
                    : true
            }).test('user_has_phone', t('user-must-have-a-phone-number'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms)
                    ? this.parent.phone || this.parent.additional_phone || [1, 6, 8].includes(this.parent.child)
                    : true
            }).test('user_has_email', t('user-must-have-an-email'), function (value) {
                return this.parent.send_email
                    ? this.parent.email || [1, 6, 8].includes(this.parent.child)
                    : true
            }),
            otherwise: yup.number().nullable()
        }),
        send_push: yup.boolean(),
        send_email: yup.boolean(),
        send_sms: yup.boolean().test('send_sms', t('select-at-least-1'), function(value){
            return this.parent.send_email || this.parent.send_whatsapp || this.parent.send_push || value
        }),
        send_whatsapp: yup.boolean(),
        subject: yup.string().when('send_email', {
            is: true,
            then: yup.string().required(t('thisFieldIsMandatory'))
        }).typeError(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
    })
}

const getDebtLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        expiration_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        message_template_id: yup.number().nullable(),
        membership_user_id: yup.mixed().when('type', {
            is: 'reports',
            then: yup.array().of(yup.object().shape({ id: yup.number()})).required(t('thisFieldIsMandatory')).min(1, t('min-1-membership-debt-selection')),
            otherwise: yup.number().required(t('thisFieldIsMandatory'))
        }),
        schedule_user_id: yup.number().nullable(),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function () {
                if (skipMetaWhatsappLinkTagValidation(this.parent)) return true;
                return this.parent.message_content?.includes(`[${t('link-to-debt')}]`)
            }),
        max_installments: yup.number().required(t('thisFieldIsMandatory')).min(1, t('onlyPositive')).typeError(t('onlyWhole')).max(24)
    }))
}

const getAllDebtsLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        expiration_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        message_template_id: yup.number().nullable(),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function (value) {
                return this.parent.message_content?.includes(`[${t('link-to-all-debts')}]`)
            }),
        max_installments: yup.number().required(t('thisFieldIsMandatory')).min(1, t('onlyPositive')).typeError(t('onlyWhole')).max(24, t('max24installmentsError'))
    }))
}

const getConfirmationLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        message_template_id: yup.number().nullable(),
        schedule_user_id: yup.number().required(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function () {
                if (skipMetaWhatsappLinkTagValidation(this.parent)) return true;
                return this.parent.message_content?.includes(`[${t('link-to-confirmation')}]`)
            }),
    }))

}

const getGroupConnectionAddUserValidationSchema = () => {
    const selection = store.getState().stepper?.flags?.selection
    return yup.object().shape({
        ...(selection === 'new' ? {
            newUser: getUserDetailsBaseValidationSchema('groupMember')
        } : {
            users_boxes_id:  yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                .test('ub-not-in-group', t('user-is-already-in-a-group'), function (value) {
                    return !this.parent.groups_ub_ids.includes(value) && !this.parent.ugc_id;
                })
        }),
        child: yup.number().required(t('thisFieldIsMandatory')).oneOf(familyArray).typeError(t('thisFieldIsMandatory')),
        head: yup.boolean()
    })
}

const getBlockedTimeValidationSchema = () => {
    const calendarType = store.getState().schedule?.calendarType
    return yup.object().shape({
        coach_fk: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
        locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        place: yup.string().typeError(t('thisFieldIsMandatory')),
        spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
    }).concat(getRepeatConfigValidationSchema());
}

const getRepeatInitialValues = (target, eventDateTime, selectedTime, selectedDay, flowName) => {
    if(target) { //for group session only, for now
        return {
            date: target.date,
            time: moment(target.time, 'HH:mm').format(dbTimeFormat),
            end_time: moment(target.end_time, 'HH:mm').format(dbTimeFormat),
            repeatConfig: null
        }
    }
    return {
        date: eventDateTime?.date ?? moment().format(dbDateFormat),
        time: selectedTime,
        end_time: eventDateTime?.end ?? moment(selectedTime, dbTimeFormat).add(1, 'h').format(dbTimeFormat),
        repeatConfig: {
            repeat: ![flowOptions.APPOINTMENT_BASIC, flowOptions.BLOCKED_TIME].includes(flowName),
            type: flowName !== flowOptions.APPOINTMENT_BASIC ? 'forever' : 'times',
            until: null,
            times: flowName === flowOptions.APPOINTMENT_BASIC ? 2 : 1,
            days: [selectedDay],
            seriesName: null
        }
    }
}

const getAvailabilityConfigInitialValues = (target, eventDateTime, selectedDay) => {
    const isEdit = store.getState().stepper.editType
    let vals = {
        date: isEdit ? target?.date : (eventDateTime?.date ?? moment().format(dbDateFormat)),
        time: null,
        end_time: null,
    }
    if(!isEdit) {
        vals.repeatConfig = {
            repeat: false,
            type: null,
            until: null,
            times: null,
            days: [selectedDay],
            seriesName: null
        }
    }
    return vals
}

const getSettingsInitialValues = (target = null) => {
    const isEdit = store.getState().stepper.editType
    const flowName = store.getState().stepper.name
    if(isEdit && target) {
        let params = {
            transparent: !!target.transparent,
            disable_cancellation_time: target.disable_cancellation_time ?? 0,
            enable_late_cancellation: !!target.enable_late_cancellation,
            enable_registration_time: target.enable_registration_time ?? 0,
            block_registration_time: target.block_registration_time ?? 0,
            has_spots: target.has_spots ?? 0,
            cancel_limit: target.cancel_limit,
            min_users: target.min_users,
            live_link: target.live_link,
            gender: target.gender ?? null,
            min_age: target.min_age ?? null,
            max_age: target.max_age ?? null,
            register_group_member: !!target.series?.register_group_member,
            allow_mid_booking: !!target.series?.allow_mid_booking
        }
        if(isEdit === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
            params.series_name = target.series.series_name
            if (flowName === flowOptions.GROUP_CLASS_FLOW || flowName === flowOptions.HUGIM_FROM_TRACK_FLOW) {
                params.paymentOptions = getPaymentOptionsValue(target)
            }
        }
        return params
    } else {
        return {
            transparent: [flowOptions.WORKSHOP_FLOW, flowOptions.HUGIM_FLOW, flowOptions.HUGIM_FROM_TRACK_FLOW].includes(flowName),
            disable_cancellation_time: 0,
            enable_late_cancellation: false,
            enable_registration_time: 0,
            block_registration_time: 0,
            cancel_limit: 0,
            has_spots: 0,
            min_users: 0,
            live_link: null,
            gender: null,
            min_age: null,
            max_age: null,
            register_group_member: false,
            allow_mid_booking: false
        }
    }
}

const getPaymentOptionsValue = (target) => {
    const trialMembership = target.series?.membership_types_all?.find(mt => mt.type === MembershipTypes.TRIAL_CLASS);
    return trialMembership ? [
        {...trialMembership,
            type: seriesPaymentDBTranslate[trialMembership.type],
            taxes: trialMembership.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
            paid: trialMembership.price > 0,
            income_card: trialMembership.income_card ?? null,
            redirectLinkEnabled: !!trialMembership.redirect_prop,
            redirectLink: trialMembership.redirect_prop?.data?.link ?? null
        }] :
        [{type: TRIAL, show_in_app: 0, price: 0, max_installments: 1, taxes: [], paid: false, redirectLinkEnabled: false, redirectLink: null, income_card: null}]
}

const getEditMultiDaysInitialValues = (eventDateTime, target) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper.editType
    if(!editType) return {}

    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return {
                date: target.date,
                days: target.series.series_events?.reduce((acc,e) => [...acc, {
                    start_time: e.start,
                    end_time: e.end,
                    day_of_week: e.day_of_week,
                    id: e.id
                }],[])
            }
        case flowOptions.HUGIM_FLOW:
        case flowOptions.HUGIM_FROM_TRACK_FLOW:
            if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
                return {
                    isUnlimited: target.series.end_date === null,
                    isOneDay: target.series.end_date === target.series.start_date,
                    date: target.date,
                    start_date: moment(target.series.start_date, dbDateFormat).format(dbDateFormat),
                    end_date: target.series.end_date ? moment(target.series.end_date, dbDateFormat).format(dbDateFormat) : null,
                    days: target.series.series_events?.reduce((acc,e) => [...acc, {
                        start_time: e.start,
                        end_time: e.end,
                        day_of_week: e.day_of_week,
                        id: e.id,
                        description: e.description
                    }],[])
                }
            } else {
                return {
                    date: target.date,
                    start_time: moment(target.time, dbTimeFormat).format(dbTimeFormat),
                    end_time: moment(target.end_time, dbTimeFormat).format(dbTimeFormat)
                }
            }
        case flowOptions.AVAILABILITY:
        case flowOptions.SPACE_AVAILABILITY:
            return {
                date: eventDateTime?.date,
                location_fk: target.location_fk,
                coach_ub_id: hasLimitedCoachViewSchedule() ? store.getState().user?.user?.id : target.coach_ub_id,
                spaces_id: target.spaces_id,
                repeat: target.repeat,
                slot_length: target.slot_length,
                break_length: target.break_length,
                block_registration_time: target.block_registration_time ?? 0,
                start_time: target.start_time,
                end_time: target.end_time,
                day_of_week: moment(target.date, dbDateFormat).day(),
                limitations: target.availability_limitations.map(item => item.category_type_id),
            }
        default:
            return {}
    }
}

const getUserDetailsBaseInitialValues = (target, isChild = false, isParent = false) => {
    const customFieldFlowName = isChild ? 'HUG_CHILD' : (isParent ? 'HUG_PARENT' : null)
    const currTarget = target?.user || target
    const flowName = store.getState().stepper.name;
    const defaultLocation = store.getState().user.user.locations_box_fk
    const editType = store.getState().stepper?.editType
    const defaults = store.getState().box.box.settings?.[DEFAULTS]

    const commonValues = {
        first_name: currTarget?.firstName || '',
        last_name: currTarget?.lastName || '',
        email: currTarget?.email || '',
        phone: currTarget?.phone || '',
        additional_phone: currTarget?.additional_phone || null,
        birthday: currTarget?.birthday ||  null,
        gender: currTarget?.gender || '',
        locations_box_fk: currTarget?.locationBoxFk || defaultLocation || '',
    }

    switch (flowName) {
        case flowOptions.LEAD:
            return {
                ...commonValues,
                allow_sms: currTarget?.allow_sms || 'yes',
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                status_fk: defaults?.lead_status_id || null,
                source_fk: currTarget?.source || defaults?.source_id || null,
                users_boxes_owner_id: currTarget?.users_boxes_owner_id || null,
                city: currTarget?.city || '',
                address: currTarget?.address || '',
                updatedUser: currTarget?.id && {
                    id: currTarget?.id || null,
                    convertMemberToLead: currTarget?.id ? currTarget?.action !== 'update' : false
                }
            }
        case flowOptions.STAFF_MEMBER:
            return {
                ...commonValues,
                personal_id: currTarget?.personal_id || '',
            }
        case flowOptions.BOOK_TO_HUG_FLOW:
        case flowOptions.BOOK_TO_HUG_CONVERT_LEAD:
            return {
                ...commonValues,
                lead_id: currTarget?.user_fk || null,
                email: currTarget?.email || null,
                emailValidated: null,
                personal_id: currTarget?.personal_id || null,
                phone: currTarget?.phone || null,
                personalIdValidated: null,
                phoneValidated: null,
                additional_phone: currTarget?.additional_phone || null,
                rfid: currTarget?.rfid || null,
                invoice_name: currTarget?.invoice_name || null,
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                allow_sms: currTarget?.allow_sms || 'yes',
                locations_box_fk: target?.eventData?.series?.locations_box_fk,
                customFields: customFieldInit(target?.eventData, editType, customFieldFlowName, true)
            }
        case flowOptions.TRACK_REGISTRATION:
            return {
                ...commonValues,
                lead_id: currTarget?.user_fk || null,
                email: currTarget?.email || null,
                emailValidated: null,
                personal_id: currTarget?.personal_id || null,
                phone: currTarget?.phone || null,
                personalIdValidated: null,
                phoneValidated: null,
                additional_phone: currTarget?.additional_phone || null,
                rfid: currTarget?.rfid || null,
                invoice_name: currTarget?.invoice_name || null,
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                allow_sms: currTarget?.allow_sms || 'yes',
                locations_box_fk: target?.track?.locations_box_id,
                customFields: customFieldInit(target, editType, customFieldFlowName ?? flowOptions.BOOK_TO_HUG_FLOW, true)
            }
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            return {
                ...commonValues,
                allow_sms: currTarget?.allow_sms || 'yes',
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                status_fk: defaults?.lead_status_id || null,
                source_fk: currTarget?.source || defaults?.source_id || null,
                users_boxes_owner_id: currTarget?.users_boxes_owner_id || null,
                phone: currTarget?.phone || null,
                email: currTarget?.email || null,
                emailValidated: null,
                phoneValidated: null,
                customFields: customFieldInit(target?.eventData, editType, flowOptions.BOOK_TO_HUG_CREATE_LEAD, true),
                locations_box_fk: target?.eventData?.series?.locations_box_fk

            }
        case flowOptions.CONNECT_USER_TO_GROUP:
            return {
                ...commonValues,
                allow_mailing_list: 'yes',
                allow_sms: 'yes',
                personal_id: null,
            }

        default:
            return commonValues;
    }
}

const getEmailAfterPurchaseInitialValues = (target) => {
    return {
        membership_types: target?.auto_actions_set_membership_types?.map?.(mt => ({...mt, value: mt.membership_types_id, id: mt.membership_types_id,})) ?? [],
        users_boxes: JSON.parse(target?.auto_actions_set_triggers?.properties || null)?.notify_list?.find?.(l => l.locations_box_id === target?.locations_box_fk)?.users_boxes?.map?.(id => ({id, value: id})) ?? [],
        locations_box_id: target?.locations_box_fk,
        trial_class: JSON.parse(target?.auto_actions_set_triggers?.properties || null)?.notify_list?.find?.(l => l.locations_box_id === target?.locations_box_fk)?.trial_class || false
    }
}

const getDocumentsAutoSendInitialValues = (target) => {
    const settings = target?.settings ?? {};
    return {
        rivhit_id: target?.rivhit_id,
        send_customer_tax_invoice_receipt: !!Number(settings.send_customer_tax_invoice_receipt ?? 1),
        send_customer_payment_receipt: !!Number(settings.send_customer_payment_receipt ?? 1),
        send_customer_tax_invoice: !!Number(settings.send_customer_tax_invoice ?? 1),
        confirmed: false,
    };
}

const getPenaltySettingsInitialValues = (target) => {
    return {
        name: target?.name || '',
        start_date: target?.start_date || moment().format(dbDateFormat),
        trigger_occurrence_count: target?.trigger_occurrence_count || 1,
        trigger_period_count: target?.trigger_period_count || 1,
        late_cancellation: target?.late_cancellation ?? true,
        check_in: target?.check_in ?? true,
        type: target?.type || 'block_app_cancel',
        reduction: target?.type_value || 1,
        block_app_cancel: target?.type_value || 1,
        block_app_no_cancel: target?.type_value || 1,
        block_book_cancel: target?.type_value || 1,
        block_book_no_cancel: target?.type_value || 1,
        no_block_cancel: target?.type_value || 1,
        time_after_class: target?.time_after_class ||  1,
        ...(target ? getPenaltyExtraPropertiesInitialValues(target) : {}),
        ...(target ? {id: target.id, message_template_id: target.message_template_id} : {})
    }
}

const getPenaltyExtraPropertiesInitialValues = (target) => {
    let message = target?.message_template?.text || '';
    const tags = getPenaltiesTags(target?.type)
    tags.forEach(tag => {
        message = message.replaceAll(`{{#${tag.id}#}}`, `[${tag.label}]`)
    });
    return {
        membership_types: target?.membership_types?.map(mt => ({id: mt.membership_types_id, value: mt.membership_types_id})) || [],
        send_push: target?.send_push ?? true,
        send_email: target?.send_email ?? false,
        send_sms: target?.send_sms ?? false,
        send_whatsapp: target?.send_whatsapp ?? false,
        free_space: target?.free_space ||  1,
        allow_free_space: !!(target?.free_space ||  0),
        properties: {...target?.properties || {}, exclude: {
            box_categories: target?.properties?.exclude?.box_categories.map(id => ({id, value: id})) || []
        }},
        exclude: target?.properties?.exclude?.box_categories?.length || false,
        message_content: message
    }
}

const getTaskDetailsInitialValues = (target) => {
    const user = store.getState().user.user
    return {
        id: target?.id,
        reminder_time: target?.reminder_time || null,
        user_fk: target?.user_fk || null,
        task_type_fk: target?.task_type_fk || null,
        assigned_to: target ? target?.assigned_to : user.user_fk,
        description: target?.description || '',
        locations_box_fk: target?.locations_box_fk || user.locations_box_fk,
        done: target?.done || 0,
        is_personal: target?.targeted === 'personal' ? 1 : 0,
        targeted: target?.is_personal ? targetAudienceTasks.PERSONAL : (target ? target.targeted : targetAudienceTasks.SPECIFIC_USER),
        task_owner_user_fk: target?.task_owner_user_fk || null,
        check_in: target?.check_in || false,
        access_control: target?.access_control || false,
        reports_users: target?.targeted === 'reports' && Object.keys(target.selectedUsers),
        is_done_button_click: false,
        user: target?.user ? {label: target?.user.full_name, value: target?.user_fk, type: getTypeByRole(target?.user?.role?.role), ...target?.user} : null
    };
}

const getSendConvertLinkInitialValues = (target) => {
    return {
        user_fk: target?.user?.user_fk || null,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        available_on_app: true,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        message_template_id: null,
        type: target?.type

    };
}

const getTrackDetailsInitialValues = (target) => {
    const box = store.getState().box.box;
    const defaultLocation = box?.locations_box?.length === 1
        ? box.locations_box[0].id
        : (store.getState().user.user.locations_box_fk ?? null);
    return {
        id: target?.id ?? null,
        name: target?.name ?? '',
        bio: target?.bio ?? '',
        start_date: target?.start_date ?? moment().format(dbDateFormat),
        end_date: target?.end_date ?? null,
        locations_box_fk: target?.locations_box_fk ?? target?.locations_box_id ?? defaultLocation,
        session_per_week: target?.session_per_week ?? null,
        department_id: target?.membership_types_all?.[0]?.department_id ?? null
    };
}

const mapUpsellInitialRows = (upsell) => {
    if (!upsell?.length) {
        return []
    }
    return upsell.map((entry, index) => ({
        membership_types_id: entry.membership_types_id ?? null,
        price: entry.price ?? null,
        order: entry.order ?? index,
        originalPrice: entry.membership_types?.price ?? null,
    }))
}

const getUpsellValidationSchema = () => yup.array().of(yup.object().shape({
    membership_types_id: yup.number().nullable(),
    price: yup.number().nullable()
        .test('upsell-price-range', t('upsell-price-range-error'), function (price) {
            if (price === null || price === undefined || price === '') {
                return true
            }
            const {originalPrice} = this.parent
            if (Number(price) < 0) {
                return false
            }
            if (originalPrice == null) {
                return true
            }
            return Number(price) <= Number(originalPrice)
        }),
    order: yup.number().nullable(),
    originalPrice: yup.number().nullable()
        .test('upsell-original-price-required', t('upsell-orphan-price-error'), function (originalPrice) {
            const {price} = this.parent
            const hasPrice = price !== null && price !== undefined && price !== ''
            if (!hasPrice) {
                return true
            }
            return originalPrice != null
        }),
})).ensure()

const getTrackPaymentInitialValues = (target) => {
    const editType = !!store.getState().stepper.editType;
    if (editType) {
        const trackMemberships = target?.membership_types_all
        return {
            paymentOptions: trackMemberships?.map(mt => {
                const type = seriesPaymentDBTranslate[mt.type];
                return {...mt,
                    sort_code: mt.sort_code_number,
                    type,
                    relative_payment: mt.relative_payment ?? (type === IMMEDIATE ? TRACK_FULL : undefined),
                    taxes: mt.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
                    addons: mt.addons?.map(addon => addon.id) ?? [],
                    redirectLinkEnabled: !!mt.redirect_prop,
                    redirectLink: mt.redirect_prop?.data?.link ?? null,
                    income_card: mt.income_card ?? null,
                };
            }),
            sort_code: trackMemberships?.find(mt => mt.sort_code_number)?.sort_code_number || null,
            sku: trackMemberships?.find(mt => mt.sku)?.sku ?? null,
        }
    }
    return {paymentOptions: [], sort_code: null, sku: null};
}

const getTrackAdvancedInitialValues = (target) => {
    const trackFormSettings = store.getState().box.box.settings?.[TRACK_FORM]
    const existingSetting = target?.id ? trackFormSettings?.find(s => s.properties?.tracks.includes(target?.id)) : null;
    const form_id = existingSetting?.properties?.form_id ?? null;
    return {
        form_id,
        register_group_member: target?.register_group_member ?? false,
        allow_mid_booking: target?.allow_mid_booking ?? false,
    }
};

const getCourseLimitationsInitialValues = (target) => ({
    courses: target?.courses ?? target?.series_track_relations?.map(relation => ({
        series_id: relation.series_id,
        session_per_week: relation.session_per_week,
    })) ?? [],
});

const getSeriesPaymentOptionsInitialValues = (target) => {
    const editType = store.getState().stepper.editType
    if(editType) {
        const fullHugMemberships = target?.series?.membership_types_all?.filter(mt => !mt.membership_types_partial_prop)
        return {
            paymentOptions: fullHugMemberships?.map(mt => ({...mt,
                sort_code: mt.sort_code_number,
                type: seriesPaymentDBTranslate[mt.type],
                taxes: mt.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
                addons: mt.addons?.map(addon => addon.id) ?? [],
                upsell: mapUpsellInitialRows(mt.upsell),
                redirectLinkEnabled: !!mt.redirect_prop,
                redirectLink: mt.redirect_prop?.data?.link ?? null,
                income_card: mt.income_card ?? null,
                auto_insert_promo_code_id: mt.auto_insert_promo_code_prop?.promo_codes_id ?? null,
                edited_price_per_session: mt.edited_price_per_session ?? null,
            })),
            sort_code: fullHugMemberships?.find(mt => mt.sort_code_number)?.sort_code_number || null,
            sku: fullHugMemberships?.find(mt => mt.sku)?.sku ?? null,
        }
    } else {
        return {paymentOptions: [], sort_code: null, sku: null, hideFullHugInSite: false}
    }
}

const getSeriesPartialOptionsInitialValues = (target) => {
    const editType = store.getState().stepper.editType
    const hugimFormSettings = store.getState().box.box.settings?.[HUGIM_FORM]
    const existingSetting = target?.series_fk ? hugimFormSettings?.find(s => s.properties?.hugim.includes(target?.series_fk)) : null;
    const form_id = existingSetting?.properties?.form_id ?? null;

    if(editType) {
        const partialHugMemberships = target?.series?.membership_types_all?.filter(mt => mt.membership_types_partial_prop)
        const res = {
            partialOptions: partialHugMemberships?.map(mt => ({...mt,
                daysOfWeek: mt.membership_types_partial_prop.frequency,
                sort_code: mt.sort_code_number,
                sku: mt.sku ?? null,
                type: seriesPaymentDBTranslate[mt.type],
                taxes: mt.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
                addons: mt.addons?.map(addon => addon.id) ?? [],
                redirectLinkEnabled: !!mt.redirect_prop,
                redirectLink: mt.redirect_prop?.data?.link ?? null,
                income_card: mt.income_card ?? null,
                auto_insert_promo_code_id: mt.auto_insert_promo_code_prop?.promo_codes_id ?? null,
                edited_price_per_session: mt.edited_price_per_session ?? null,
            })),
            form_id
        }
        return res;
    } else {
        return {partialOptions: [], form_id}
    }
}


const getRequiredFieldsSettingsInitialValues = (initProps) => {
    const type = initProps?.type ?? USER_FIELDS;
    const boxSettings = store.getState().box.box.settings?.[type]
    if (boxSettings) return {properties: boxSettings, prop_name: type};
    let initialProps = {};
    if (!boxSettingsProps[type]) return null;
    boxSettingsProps[type].fields.forEach(prop => {
        initialProps[prop] = getSettingsObjectByType(prop, boxSettingsProps[type].flows, type)
    });
    return {properties: initialProps, prop_name: type};
}

const getAccountCardsSettingsInitialValues = () => {
    return {
        locationId: null,
        accounting_separation: false,
        location_options: [],
        cards: [],
        customer_management_type: 1,
        initial_customer_management_type: 1,
        has_foreign_numbers: false,
        branch_account_numbers: [],
        show_branch_customer_cards: false,
        transaction_types: [],
        initial_transaction_types: [],
    };
}

const getOrganizationPriceListValidationSchema = () => {
    const isFilled = (value) => value != null && value !== '';
    return yup.object().shape({
        branches: yup.mixed().test('subsidy-required', t('thisFieldIsMandatory'), (branches) => !!branches && Object.values(branches).every((branch) => branch.mode === 'all'
            ? (!branch.allIds.length || isFilled(branch.allSubsidy))
            : branch.rows.every((row) => isFilled(row.subsidy)))),
    });
}

const getOrganizationPriceListInitialValues = (initProps) => ({
    usersBoxesId: initProps?.target?.usersBoxesId ?? null,
    locationId: null,
    branches: null,
});

const getUserChargeSettingInitialValues = (initProps) => {
    const paymentProvider = initProps?.paymentProvider
    if(!paymentProvider) return null
    let initialProps = {};
    const boxSettings = store.getState().box.box.settings?.[CHARGE_SETTING]
    if (boxSettings) return {properties: boxSettings, prop_name: CHARGE_SETTING};
    siteChargeOptions[paymentProvider].forEach(prop => {
        initialProps[prop] = {site: prop === 'card', app: false}
    })
    return {properties: initialProps, prop_name: CHARGE_SETTING};
}

const getSiteTrialSettingsInitialValues = () => {
    const siteTrialSettings = store.getState().box.box.settings?.[SITE_TRIAL_SETTINGS]
    if(siteTrialSettings) return siteTrialSettings
    else {
        return {
            newLead: {status_id: createdStatusId, source_id: null},
            existingLead: {status_id: null, source_id: null}
        }
    }
}

const getGatesActivityHoursInitialValues = () => {
    const gates = store.getState().box.box.locations_box?.map(location => location.gates).flat().filter(gate => !gate.is_exit);
    const isOne = gates.length === 1
    return {
        gates: gates.map(gate => ({
            id: gate.id,
            name: gate.name,
            locations_box_id: gate.locations_box_id,
            multiDayConfig: activityHoursToMultiDayConfig(gate.properties?.ACTIVITY_HOURS)
        })),
        multiDayConfig: isOne ? activityHoursToMultiDayConfig(gates[0].properties?.ACTIVITY_HOURS) : []
    };
}

const activityHoursToMultiDayConfig = (activityHours) => {
    let multiDayConfig = [];
    if (activityHours) {
        let index = null;
        for (const [key, value] of Object.entries(activityHours)) {
            index = daysEnum.findIndex(day => day === key);
            if (value !== 'closed' && value) {
                multiDayConfig.push({
                    day: index,
                    setting: value?.map(([start_time, end_time]) => ({start_time, end_time}))
                })
            }
        }
    }
    return multiDayConfig;
}

const getLeadFormSiteSettingsInitialValues = () => {
    const siteLeadFormSettings =  store.getState().box.box.settings?.[SITE_LEAD_FORM_SETTINGS]
    if(siteLeadFormSettings) return siteLeadFormSettings
    let initialProps = {};
    siteFormLeadFieldOptions.forEach(prop => {
        initialProps[prop] = {required: true};
    });
    return {
        status_id: createdStatusId,
        source_id: null,
        show_on_site: false,
        ...initialProps
    }

}

const getCreateTaskTypeInitialValues = (target) => {
    return {
        task_type_color: target?.task_type_color || '#D0FFF9',
        type: target?.type || '',
        check_in: target?.check_in || false,
        access_control: target?.access_control || false,
        id: target?.task_type_id

    };
}

const getSendMembershipLinkInitialValues = (target) => {
    const groupConnections = Array.isArray(target?.groupData) ? target.groupData : (target?.groupData?.data ?? [])
    const memberConnection = groupConnections.find(conn => conn.user_box?.user_fk === target?.user?.user_fk)
    return {
        user_fk: target?.user?.user_fk || null,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        additional_phone: target?.user?.additional_phone || null,
        child: target?.user?.child ?? memberConnection?.user_box?.child ?? null,
        available_on_app: true,
        item_id: null,
        send_push: target?.user?.type === 'user',
        send_sms: target?.user?.type === 'lead',
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        message_template_id: null,
        type: target?.type
    };

}

const getDebtLinkInitialValues = ({target, initProps}) => {
    const isReport = target?.type === 'reports'
    let membership_user_id = target?.user?.membership_user_fk
    let maxInstallments = 1
    if(isReport) {
        membership_user_id = Object.values(target.selectedUsers).reduce((acc, mtArray) => [...acc, ...mtArray], [])
    }
    if(target?.user?.membership_user?.membership_types) {
        maxInstallments = target.user.membership_user.membership_types.max_installments ?? 1
    }
    const groupConnections = Array.isArray(target?.groupData) ? target.groupData : (target?.groupData?.data ?? [])
    const memberConnection = groupConnections.find(conn => conn.user_box?.user_fk === target?.user?.user_fk)
    return {
        user_fk: target?.user?.user_fk,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        additional_phone: target?.user?.additional_phone || null,
        child: target?.user?.child ?? memberConnection?.user_box?.child ?? null,
        send_push: false,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        message_template_id: null,
        membership_user_id: membership_user_id,
        expiration_date: moment().add(1, 'days').format(dbDateFormat),
        schedule_user_id: target?.user?.schedule_user_id,
        type: isReport ? 'reports' : undefined,
        max_installments: maxInstallments
    }
}

const getAllDebtsLinkInitialValues = ({target}) => {
    const isReport = target?.type === 'reports'
    return {
        user_fk: target?.user?.user_fk,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        send_push: false,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        message_template_id: null,
        expiration_date: moment().add(1, 'days').format(dbDateFormat),
        type: isReport ? 'reports' : undefined,
        max_installments: 1
    }
}

const getUserNoteExportInitialValues = ({target}) => {
    const lang = store.getState().userSettings.lang
    const name = target?.relatable?.box_categories?.name
    const date = target?.relatable?.date
    let subject = ''
    if(name && date) {
        const box = store.getState().box.box;
        const dateFormat = box ? box.locations_box[0].date_format : null
        subject = t('user-note-export-default-subject', {name, date: moment(date, dbDateFormat).format(dateFormat)})
    }
    return {
        locale: lang?.language === 'Hebrew' ? 'he' : 'en',
        subject: subject,
        message_content: t(`user-note-export-content-default${target?.relatable ? '-schedule' : ''}`),
        email_to: target?.users_boxes?.user?.email ?? '',
        note_relation_id: target?.note_relation_id ?? null
    }
}

const getPromoCodeInitialValues = ({target, initProps}) => {
    const box = store.getState().box.box
    const locations = box.locations_box
    if (target) {
        const hasTiered = !!(target.tiered_promo_codes && target.tiered_promo_codes.length > 0)
        return {
            id: target.id,
            name: target.name,
            expiration_date: target.expiration_date ?? null,
            discount_amount: target.discount_amount,
            description: target.description ?? "",
            limit_quantity: target.limit_quantity,
            location_id: target.location_id,
            recurring_cycles: hasTiered ? target.tiered_promo_codes.length : target.recurring_cycles,
            tiered_promo_codes: hasTiered ? target.tiered_promo_codes.map((tpc, i) => ({ discount_amount: tpc.discount_amount, cycle: i + 1 })) : null,
            membership_types: [],
            internal: !!target.internal,
            staff: target.promo_staff_prop?.data?.staff ?? []
        }
    }
    return {
        name: '',
        expiration_date: null,
        discount_amount: null,
        limit_quantity: null,
        location_id: locations.length > 1 ? null : locations[0].id,
        recurring_cycles: null,
        tiered_promo_codes: null,
        membership_types: [],
        internal: initProps?.internal,
        staff: initProps?.internal ? [Roles.BOXADMIN] : []
    }
}

const getSendConfirmationLinkInitialValues = ({target, initProps}) => {
    const sendConfirmationLinkMessage = store.getState().userSettings.sendConfirmationLinkMessage
    return {
        user_fk: target?.user?.user_fk,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        send_push: false,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: sendConfirmationLinkMessage || t('default-message-send-confirmation'),
        message_template_id: null,
        schedule_user_id: target?.user?.schedule_user_id
    }
}

const getGroupConnectionAddUserInitialValues = (target) => {
    return {
        newUser: getUserDetailsBaseInitialValues('member'),
        users_boxes_id: null,
        child: 1,
        head: false,
        groups_id: target?.groupData?.[0]?.groups_id || null,
        groups_ub_ids: target?.groupData?.[0] ? target?.groupData?.map(member => member?.users_boxes_id) : [target?.user?.id]
    }
}

const getEditMultiDaysValidationSchema = () => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper.editType

    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return getWorkshopSeriesDaysEditValidationSchema().shape({
                date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                    return moment(value, dbDateFormat).format(dbDateFormat) === value
                })
            })
        case flowOptions.AVAILABILITY:
            return getEditAvailabilityBasicValidationSchema().shape({
                coach_ub_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.SPACE_AVAILABILITY:
            return getEditAvailabilityBasicValidationSchema().shape({
                spaces_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.HUGIM_FLOW:
        case flowOptions.HUGIM_FROM_TRACK_FLOW:
            if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
                return getWorkshopSeriesDaysEditValidationSchema().shape({
                    isUnlimited: yup.boolean(),
                    isOneDay: yup.boolean(),
                    date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    start_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    end_date: yup.string().when("isUnlimited", {
                        is: true,
                        then: yup.string().nullable(true).test('is-null', 'end_date must be null', value => value === null), //must be null when isUnlimited=true
                        otherwise: yup.string().required(t('thisFieldIsMandatory')).when(['start_date', 'isOneDay'], (start_date, isOneDay, schema) => {
                            const start = moment(start_date, dbDateFormat)
                            return schema.test({
                                test: end => end && (isOneDay ? moment(end, dbDateFormat).isSame(start) : moment(end, dbDateFormat).isAfter(start)),
                                message: t('shiftTimeError')
                            })
                        }).test('date-format', 'invalid date', function(value){
                            return value && (moment(value, dbDateFormat).format(dbDateFormat) === value)
                        }),
                    })
                })
            } else {
                return yup.object().shape({
                    date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                        return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                    }),
                    end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                        const start = moment(start_time, dbTimeFormat)
                        return schema.test({
                            test: end => moment(end, dbTimeFormat).isAfter(start),
                            message: t('shiftTimeError')
                        })
                    }).test('time-format', 'invalid time', function (value) {
                        console.log(' end time',value, moment(value, dbTimeFormat).format(dbTimeFormat))
                        return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                    }),
                })
            }
        default:
            return yup.object().shape({})
    }
}

const getWorkshopSeriesDaysEditValidationSchema = () => {
    return yup.object().shape({
        days: yup.array().of(yup.object().shape({
            start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                const start = moment(start_time, dbTimeFormat)
                return schema.test({
                    test: end => moment(end, dbTimeFormat).isAfter(start),
                    message: t('shiftTimeError')
                })
            }).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            day_of_week: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
            description: yup.string().min(2, t('nameErrorMsg')).max(350, t('nameErrorMsg')).nullable()
        }))
    })
}

const getSpaceConfigValidationSchema = () => {
    return yup.object().shape({
        locations_box_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        name: yup.string().required(t('thisFieldIsMandatory')).min(2, t('nameErrorMsg')).max(20, t('nameErrorMsg')),
        availabilityInfo: getAvailabilityBasicValidationSchema().nullable()
    })
}

const getAvailabilityBasicValidationSchema = () => {
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        repeat: yup.boolean().required(),
        slot_length: yup.number().min(1,`${t('largerThanErrorMsg')}1`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        break_length: yup.number().min(0,`${t('largerThanErrorMsg')}0`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        multiDayConfig: yup.array().of(yup.object().shape({
            day: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
            setting: yup.array().of(yup.object().shape({
                start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                    const start = moment(start_time, dbTimeFormat)
                    return schema.test({
                        test: end => moment(end, dbTimeFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                limitations: yup.array().ensure()
            })).test('no-time-overlap', t('availability-times-overlap'), function (settings) {
                if (!settings || settings.length < 2) return true
                const complete = settings.filter(s => s?.start_time && s?.end_time)
                if (complete.length < 2) return true
                const sorted = [...complete].sort((a, b) => a.start_time.localeCompare(b.start_time))
                return sorted.every((curr, i) => i === 0 || curr.start_time >= sorted[i - 1].end_time)
            })
        })).min(1, t('one-day-minimum')),
    })
}

const getEditAvailabilityBasicValidationSchema = () => {
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        slot_length: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        break_length: yup.number().min(0,`${t('largerThanErrorMsg')}0`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
            const start = moment(start_time, dbTimeFormat)
            return schema.test({
                test: end => moment(end, dbTimeFormat).isAfter(start),
                message: t('shiftTimeError')
            })
        }).test('time-format', 'invalid time', function (value) {
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        day_of_week: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
        limitations: yup.array().ensure()
    })
}

const getPenaltiesSettingsValidationSchema = () => {
    const target = store.getState().stepper.props.target;
    const all = store.getState().stepper.props.all?.filter(p => p.id !== target?.id)?.map(p => p.name);
    const getYupByType = (type) => {
        return yup.number().when('type', {
            is: value => value === type,
            then: yup.number().min(1).required(t('thisFieldIsMandatory'))
        })
    }
    return yup.object().shape({
        name: yup.string().required(t('thisFieldIsMandatory')).test('name-unique', t('name-must-be-unique'), function (val) {
            return !all.includes(val);
        }),
        start_date: yup.string().required().test('start_date', t('start-date-must-be-a-future-date'), function (val) {
            if (target && target.start_date < moment().format(dbDateFormat)) {
                return true;
            }
            return val >= moment().format(dbDateFormat)
        }),
        trigger_occurrence_count: yup.number().min(1).required(t('thisFieldIsMandatory')),
        trigger_period_count: yup.number().min(1).required(t('thisFieldIsMandatory')),
        late_cancellation: yup.boolean().test('late_cancellation', t('select-at-least-1'), function(value){
            return this.parent.check_in || value
        }),
        check_in: yup.boolean().test('check_in', t('select-at-least-1'), function(value){
            return this.parent.late_cancellation || value
        }),
        type: yup.string().oneOf(['reduction', 'block_app_cancel', 'block_app_no_cancel', 'block_book_cancel', 'block_book_no_cancel', 'no_block_cancel']).required(),
        reduction: getYupByType('reduction'),
        block_app_cancel: getYupByType('block_app_cancel'),
        block_app_no_cancel: getYupByType('block_app_no_cancel'),
        block_book_cancel: getYupByType('block_book_cancel'),
        block_book_no_cancel: getYupByType('block_book_no_cancel'),
        no_block_cancel: getYupByType('no_block_cancel'),
        time_after_class: yup.number().oneOf([1,2,3,4]).required()
    }).concat(target ? getExtraPenaltiesPropertiesValidationSchema() : yup.object().shape({}));
}

const getExtraPenaltiesPropertiesValidationSchema = () => {
    return yup.object().shape({
        membership_types: yup.array(yup.object().shape({
            id: yup.number().required()
        })).min(1, t('select-at-least-1-plan-or-session-pack')),
        available_in_app: yup.boolean(),
        item_id: null,
        send_push: yup.boolean(),
        send_email: yup.boolean(),
        send_sms: yup.boolean(),
        send_whatsapp: yup.boolean(),
        message_content: yup.string().required(t('thisFieldIsMandatory')),
        free_space: yup.number(t('onlyWhole')).integer(t('onlyWhole')).min(0, t('onlyPositive')).typeError(t('onlyWhole')),
        properties: yup.object().shape({
            exclude: yup.array(yup.object().shape({
                box_categories: yup.array(yup.number())
            })).nullable()
        }).nullable()
    })
}

const getSendConvertLinkValidationSchema = () => {
    return yup.object().shape({
        user_fk: yup.number().when('type', {
            is: undefined,
            then: yup.number().required(t('thisFieldIsMandatory')).test('user_has_phone_email', t('user-must-have-a-phone-number-and-email'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) && this.parent.send_email ? this.parent.phone && this.parent.email : true
            }).test('user_has_phone', t('user-must-have-a-phone-number'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) ? this.parent.phone : true
            }).test('user_has_email', t('user-must-have-an-email'), function (value) {
                return (this.parent.send_email) ? this.parent.email : true
            }),
            otherwise: yup.number().nullable()
        }),
        send_email: yup.boolean(),
        send_sms: yup.boolean().test('send_sms', t('select-at-least-1'), function(value){
            return this.parent.send_email || this.parent.send_whatsapp || value
        }),
        send_whatsapp: yup.boolean(),
        message_template_id: yup.number().nullable(),
        subject: yup.string().when('send_email', {
            is: true,
            then: yup.string().required(t('thisFieldIsMandatory'))
        }),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
        .test('link-required', t('link-is-required'), function () {
            if (skipMetaWhatsappLinkTagValidation(this.parent)) return true;
            return this.parent.message_content?.includes(`[${t('link-to-convert')}]`)
        }),
    })
}

const getBasicWorkshopValidationSchema = () => {
    return yup.object().shape({
        start_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        multiDayConfig: yup.object().shape({
            days: yup.array().of(yup.object().shape({
                day: yup.number().min(0).max(6),
                start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                    const start = moment(start_time, dbTimeFormat)
                    return schema.test({
                        test: end => moment(end, dbTimeFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                description: yup.string().min(2, t('nameErrorMsg')).max(350, t('nameErrorMsg')).nullable()
            })).min(1, t('one-day-minimum')),
            seriesName: yup.string().nullable()
        })
    })
}

const getPaymentOptionValidationSchema = (types = null, withRedirect = false) => {
    const typesArray = types ?? [HOK, TRIAL, IMMEDIATE, ONETIME]
    let schema = yup.object().shape({
            type: yup.string().oneOf(typesArray),
            show_in_app: yup.number().integer().min(0).max(3),
            max_installments: yup.number().integer().min(1).max(24).typeError(t('thisFieldIsMandatory')),
            price: yup.number().when('type', {
                is: type => type === HOK,
                then: yup.number().min(1, t('price-zero-invalid')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                otherwise: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
            }),
            taxes: yup.array().of(yup.number().required(t('thisFieldIsMandatory'))).ensure(),
            auto_insert_promo_code_id: yup.number().nullable(),
        })
    if(withRedirect) {
        schema = schema.concat(yup.object().shape({
            redirectLinkEnabled: yup.boolean(),
            redirectLink: yup.string().when('redirectLinkEnabled', {
                is: true,
                then: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')).max(2000),
                otherwise: yup.string().nullable()
            })
        }))
    }
    return schema
}